var testhtml =
    '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" style="margin:0"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">#HEADER#</head><body style="margin:0;">#CONTENT#</body></html>';
var htmlHeadSource = `<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml">
        <head>
            <title>Source Code</title>
            <link rel="stylesheet" href="#PATHSOURCE#"/>#HEADER#
        </head>
        <body>#CONTENT#</body>
    </html>`;
var minihtml =
    '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" style="margin:0"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">#HEADER#</head><body designMode="On" contentEditable = "true" style="margin:0;background-color:#ffffff;">#CONTENT#</body></html>';
var previewhtml =
    '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" style="margin:0"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">#HEADER#</head><body >#CONTENT#</body></html>';
window.rvLang = function (key) {
    return key;
};
// curImage stage image editor
//var curImage = '';
//var rightBarActive = false;
(function ($) {
    var setToolbar = '';
    var setRightbar = '';
    var setFooter = '';
    //    RVwys = {};
    RVwys.baseUrl = parent.wex.url.baseUrl;
    RVwys.aTarget = {};
    RVwys.oElement = [];
    RVwys.document = false;
    RVwys.editorContent = [];
    RVwys.currentEditor = false;
    RVwys.currentiFrame = false;
    RVwys.plugin = {};
    RVwys.oEventsDesignViewByWidget = {};
    RVwys.oEventsDesignView = [];
    RVwys.oEventsSourceView = [];
    RVwys.toolbar = $('<div/>');
    RVwys.footer = $('<div/>');
    RVwys.isStart = false;
    RVwys.inSource = false;
    RVwys.editorSource = false;
    RVwys.editorFrameSource = false;
    RVwys.editorFrameDoc = false;
    RVwys.processUpdateSource = false;
    RVwys.processUpdateDesign = false;
    RVwys.startOffset = false;
    RVwys.endOffset = false;
    RVwys.oButtonStateByTags = {};
    RVwys.isTagImage = false;
    RVwys.shiftKey = false;
    RVwys.ctrlKey = false;
    RVwys.altKey = false;
    RVwys.aSwitchTag = {
        img: '.dtbarimage',
        video: '.dtbarimage',
        canvas: '.dtbarimage',
        table: '.dtbartable',
        th: '.dtbartable',
        tr: '.dtbartable',
        td: '.dtbartable',
    };
    RVwys.opts = {};
    RVwys.opts = { target: RVwys.opts.target };
    RVwys.start = function (opts) {
        if (opts) {
            this.opts = opts;
        }
        if (this.isStart) {
            this.stop();
            this.interfaceClear();
        } else {
            this.EditorByClass();
            this.startUIkit();
            this.isStart = true;
        }
    };

    RVwys.startUIkit = function () {
        if (RVwys.plugin['EditorMode']) {
            parent.$('.wys-desktopmode').trigger('click');
        }

        if (themeName == 'uikit') {
            setTimeout(function () {
                console.log('EditorByUIkit-->');

                // remove comment tag
                $('.editable_area, .designWidgets')
                    .contents()
                    .filter(function () {
                        return this.nodeType == 8 || this.nodeType == 3;
                    })
                    .remove();

                RVwys.EditorByUIkit();
                $('#widgetAll').trigger('click');
                //parent.RVwys.nextMainLoad(parent.rvLang('Done'));
                setTimeout(function () {
                    parent.$('#rvwysDetailLoad').hide();
                    parent.$('#msg-mainload').hide();
                    $('.RVWYSIWYGAREA').removeClass(RVwys.effectClass);

                    var oBegin = $('.sidebar-center')
                        .find('.RVWYSIWYGAREA')
                        .eq(0);
                    if (oBegin.get(0)) {
                        oBegin.get(0).focus();
                    }
                    /*
                    $('html, body').animate({
                        scrollTop: oBegin.offset().top
                       }, 1000,function(){


                           //RVwys.imageEditorToolResetPos();
                       });
                       */
                }, 50);
            }, 50);
        }
    };

    RVwys.interfaceDesignMode = function (opt) {
        var bodycontent = parent.$('#frameBody');
        var bodyToolbar = parent.$('#wys-toolbar');
        var footerToolbar = parent.$('#wys-footer');
        var rvinnerWrapper = parent.$('.rvinner-wrapper');
        /*
        if ($.browser.msie || $.browser.msie11) {
            if (opt || $(window).height()!=bodycontent.height()) {
                //bodycontent.height($(window).height() - (bodyToolbar.height()+footerToolbar.height()));
            	bodycontent.height($(window).height() - rvinnerWrapper.height());
            }
        } else {
            //r = bodycontent.height() - (bodyToolbar.height()+footerToolbar.height());
        	var r = bodycontent.height() - (rvinnerWrapper.height());
        	console.log('bodycontent.height()-->'+bodycontent.height())
        	console.log('rvinnerWrapper.height()-->'+rvinnerWrapper.height())
            bodycontent.height(r);
        	console.log('bodycontent.height()-->'+bodycontent.height())
        }
        */
        //r = bodycontent.height() - (bodyToolbar.height()+footerToolbar.height());
        var r = bodycontent.height() - rvinnerWrapper.height();
        console.log('bodycontent.height()-->' + bodycontent.height());
        console.log('rvinnerWrapper.height()-->' + rvinnerWrapper.height());
        bodycontent.height(r);
        console.log('bodycontent.height()-->' + bodycontent.height());
        return this;
    };
    RVwys.interfaceClear = function () {
        bodycontent = parent.$('#frameBody');
        bodyToolbar = parent.$('.wys-toolbar');
        footerToolbar = parent.$('.wys-footer');
        bodycontent.height(bodycontent.height($(document).height()));
    };
    RVwys.stop = function () {
        var oRVwys = this;
        parent
            .$('.RVwys')
            .remove()
            .end()
            .each(function () {
                $(RVwys.opts.target)
                    .css({ display: 'block' })
                    .attr({
                        designMode: 'off',
                        contentEditable: 'false',
                    })
                    .removeClass('editorCurrent editorCurrentActive')
                    .off()
                    .each(function () {
                        $(this).unplaceHolders();
                    });
                oRVwys.isStart = false;
            });
        $(document).trigger('editorClose');
        $(document).trigger('editorCompleted');
        $(document).trigger('widgetClose');
        $(document).trigger('widgetCompleted');
        $(document).off('editorReady');
        $(document).off('designReady');
    };
    RVwys.execDesignMode = function (cmd, showUI, val) {
        $(this.currentiFrame).focus();
        var fo = $('#frameBody').get(0)
            ? $('#frameBody').get(0).contentWindow
            : parent.$('#frameBody').get(0).contentWindow;
        if (fo.RVwys.history.curLevel == 0 && String(this.getRange()) == '') {
            //'nodeType' look this http://www.w3schools.com/jsref/prop_node_nodetype.asp
            if (this.getRange().commonAncestorContainer.nodeType == 3) {
                RVwys.insertRollHTML('<history></history>');
            } else {
                $(this.currentiFrame).append($('<history></history>'));
            }

            fo.RVwys.history.add();
            $('history').remove();
        }
        var isCom = this.currentEditor.execCommand(cmd, showUI, val);
        var range = this.getRange();
        fo.RVwys.history.add();
        $(this.currentiFrame).focus();
        this.reSelectRange(range);
        $(this.currentEditor).find('.layoutResize').remove();
        // RVwys.updateSource();
    };

    RVwys.getRangeHTML = function (obj, rangeText) {
        var tagActive = {};
        tagActive['div'] = true;
        tagActive['p'] = true;
        tagActive['table'] = true;
        var tag = obj.get(0).tagName.toLowerCase();
        if (obj.parent().text() != rangeText) {
            return obj;
        }
        return obj
            .parent()
            .get(0)
            .className.match(/RVEditor/gi) || tagActive[tag]
            ? obj
            : this.getRangeHTML(obj.parent(), rangeText);
    };
    RVwys.isRangeText = function (range) {
        var rangeText = false;
        if (range) {
            rangeText = 'text' in range ? range.text : '' + range + '';
            return rangeText != '' ? rangeText : false;
        }
        return false;
    };

    RVwys.getRangeParent = function () {
        var tagParent = false;
        var range = this.getRange();
        if (range) {
            if (range.startContainer) {
                tagParent = $(range.startContainer).parent();
            } else {
                $(RVwys.currentiFrame).focus();
                try {
                    tagParent = $(range.parentElement());
                } catch (e) {
                    tagParent = $(range.commonParentElement());
                }
            }
        }
        return tagParent;
    };
    RVwys.getRangeParentNotFocus = function () {
        var tagParent = false;
        var range = this.getRange();
        if (range) {
            if (range.startContainer) {
                tagParent = $(range.startContainer).parent();
            } else {
                try {
                    tagParent = $(range.parentElement());
                } catch (e) {
                    tagParent = $(range.commonParentElement());
                }
            }
        }
        return tagParent;
    };
    RVwys.selectRange = function (cRange) {
        if (cRange) {
            if ('select' in cRange) {
                cRange.select();
            } else {
                var sel = RVwys.currentEditor.getSelection();
                sel.addRange(cRange);
                $(RVwys.currentIframe).focus();
            }
            return cRange;
        }
        return false;
    };
    RVwys.selectInsertHTML = function (range, code) {
        //alert(range)
        console.log('selectInsertHTML');
        console.log(this.currentEditor);

        var sel = this.currentEditor.getSelection();
        var isSelect = false;
        var keyCode;
        if (range) {
            keyCode = code;
            var typeofCode = (typeof code).toLowerCase();
            range.deleteContents();
            $(RVwys.currentiFrame).focus();
            if (typeofCode == 'object') {
                //range.collapse(false);
                console.log('selectInsertHTML obj');
                range.insertNode(code.get(0));
                isSelect = true;
            } else {
                keyCode = $('<div>' + code + '</div>').get(0);
                try {
                    range.insertNode(keyCode.firstChild);
                } catch (e) {
                    console.log(e);
                    /*
                	var his = document.createTextNode('error'+e);
                	range.insertNode(his);
                    range.insertNode(keyCode.firstChild);
                    */
                }
            }
            $(RVwys.currentiFrame).focus();
            if (isSelect) {
                range = RVwys.currentEditor.createRange();
                sel.removeAllRanges();
                range.selectNode(code.get(0));
            } else {
                sel.removeAllRanges();
                range.collapse(false);
            }
            sel.addRange(range);
            return range;
        }
        keyCode = $('<div>' + code + '</div>');
        var newSel = RVwys.currentEditor.createRange();
        newSel.pasteHTML(keyCode.html());

        return false;
    };

    RVwys.insertRollHTML = function (code) {
        /*
        if ($.browser.msie || $.browser.msie11) { // $.browser.msie11
            if (window.getSelection) {

                var sels = this.currentEditor.getSelection();
                if (sels.rangeCount > 0) {
                var range = sels.getRangeAt(0);
                range.deleteContents();
                range.collapse(false);
                var el = this.currentEditor.createElement("div");
                var typeofCode = (typeof(code)).toLowerCase();
                if(typeofCode == 'object') {
                    $(el).append(code);
                }  else {
                    el.innerHTML = code;
                }
                var frag = this.currentEditor.createDocumentFragment(), node, lastNode;
                while ( (node = el.firstChild) ) {
                    lastNode = frag.appendChild(node);
                }
                typeofCode = (typeof(code)).toLowerCase();
                range.insertNode(frag);
                } else {
                    //selection = RVwys.selectRange(range);
                    var typeofCode = (typeof(code)).toLowerCase();
                    //el.innerHTML = (typeofCode == 'object') ? code.html():code
                    if(typeofCode == 'object') {
                        var g = $('<div></div>')
                        g.append(code);
                        var outcode = g.html();
                        g.remove();
                    } else {
                        var outcode = code;
                    }
                    RVwys.insertRollHTML(code);
                }
            }
        }else {
            var range = this.getRange();
            this.selectInsertHTML(range,code);
        }
        */
        var range = this.getRange();
        this.selectInsertHTML(range, code);
        setTimeout(function () {
            RVwys.updateSource();
            $(RVwys.currentiFrame).focus();
        }, 50);
    };
    RVwys.insertHTML_HISTORY = function (code) {
        try {
            var fo = $('#frameBody').get(0).contentWindow;
        } catch (e) {
            var fo = parent.$('#frameBody').get(0).contentWindow;
        }
        if (fo.RVwys.history.curLevel == 0) {
            RVwys.insertHTML('<history></history>');
            fo.RVwys.history.add();
        }
        fo.$('history').remove();
        RVwys.insertHTML(code);
        RVwys.insertHTML('<history></history>');
        fo.RVwys.history.add();
    };

    RVwys.insertHTML = function (code) {
        try {
            var fo = $('#frameBody').get(0).contentWindow;
        } catch (e) {
            console.log('error c');
            console.log(e);
            var fo = parent.$('#frameBody').get(0).contentWindow;
        }
        RVwys.insertRollHTML('<history></history>');
        fo.RVwys.history.add();
        fo.$('history').remove();
        /*
        if ($.browser.msie || $.browser.msie11) { // $.browser.msie11
            if (window.getSelection) {
                var sels = this.currentEditor.getSelection();
                if (sels.rangeCount > 0) {
                    var range = sels.getRangeAt(0);
                    range.deleteContents();
                    range.collapse(false);
                    var el = this.currentEditor.createElement("div");
                    var typeofCode = (typeof(code)).toLowerCase();
                    if(typeofCode == 'object') {
                        $(el).append(code);
                    } else {
                        el.innerHTML = code;
                    }
                    var frag = this.currentEditor.createDocumentFragment(), node, lastNode;
                    while ( (node = el.firstChild) ) {
                        lastNode = frag.appendChild(node);
                    }
                    typeofCode = (typeof(code)).toLowerCase();
                    range.insertNode(frag);
                } else {
                    var typeofCode = (typeof(code)).toLowerCase();
                    //el.innerHTML = (typeofCode == 'object') ? code.html():code
                    if(typeofCode == 'object') {
                        var g = $('<div></div>')
                        g.append(code);
                        var outcode = g.html();
                        g.remove();
                    } else {
                        var outcode = code;
                        RVwys.insertRollHTML('<history></history>');
                    }
                    RVwys.insertHTML(outcode);
                }
            }
        } else {
            var range = this.getRange();
            if ((typeof(code)).toLowerCase() != 'object') {
             RVwys.insertRollHTML('<history> </history> ');
            }
            this.selectInsertHTML(range,code);
        }
        */
        var range = this.getRange();
        console.log('range: ', range);
        if ((typeof code).toLowerCase() != 'object') {
            RVwys.insertRollHTML('<history> </history> ');
        }
        this.selectInsertHTML(range, code);

        fo.RVwys.history.add();
        setTimeout(function () {
            RVwys.updateSource();
            $(RVwys.currentiFrame).focus();
        }, 50);
    };
    RVwys.insertHTMLSelect = function (code) {
        var range = this.getRange();
        this.insertHTML(code);
        setTimeout(function () {
            RVwys.reSelectRange(range);
        }, 100);
    };

    RVwys.EditorAddEvent = function (obj, isFocus) {
        console.log(
            "$('.editable_area').length()" + $('.editable_area').length
        );
        if ($('.editable_area').length == 0) {
            setTimeout(function () {
                RVwys.EditorAddEvent(obj, isFocus);
            }, 500);
            return false;
        }

        var wEditor = this;
        var EObject;
        wEditor.aTarget = {};
        wEditor.oElement = [];
        wEditor.currentEditor = [];
        wEditor.currentiFrame = [];
        var oKey = { 16: 'shift', 17: 'ctrl', 18: 'alt' };
        if ((typeof obj).toLowerCase() == 'object') {
            EObject = obj;
        } else {
            EObject = $(obj);
        }
        var iEtor = 0;
        console.log('list all event');
        console.log($._data(EObject, 'events'));
        EObject.each(function () {
            iEtor++;
        });
        EObject.off()
            .on(
                'keypress,submit,load,click,dblclick,change,resize,focus,mouseenter,unload,blur,mouseleave,scroll',
                function (e) {
                    var curRange = $(e.target);
                    const editEvent = curRange.attr('data-w:' + e.type);
                    if (!RVwys.wysAction(e, editEvent)) {
                        return false;
                    }
                }
            )

            .keydown(function (e) {
                if ($('.cropper-icon-image-editor').is(':visible')) {
                    return false;
                }

                var curRange = $(e.target);
                const editEvent = curRange.attr('data-w:' + e.type);
                if (!RVwys.wysAction(e, editEvent)) {
                    return false;
                }

                if (parent.$('.wys-rowTwo').is(':visible')) {
                    parent.curImage = false;
                    parent.focusImage = false;
                }
                $(
                    '.image-editor-tool,.image-editor-overlay,.icon-widget-preview'
                ).hide();
                parent.$('.wys-dynamic').toggle(parent.dynamicShow);
                parent.$('.wys-rowTwo').toggle(!parent.dynamicShow);

                parent.$('.imageLib').hide();

                console.log('keydown ---->' + parent.dynamicShow);

                RVwys.swDyamicToolbar($(e.target));
                $('.layoutResize').remove();
                var range = RVwys.getRange();
                //console.log('tagget-->'+range.isCollapsed)
                wEditor.currentEditor = RVwys.document
                    ? RVwys.document
                    : document;
                parent.RVwys.currentEditor = document;
                //shif = 16 , ctrl = 17, alt = 18
                console.log('history key : ', e.key);
                console.log('history-keydown->' + e.keyCode);

                var fo =
                    frameBody?.contentWindow ??
                    parent.$('#frameBody').get(0).contentWindow;

                if (oKey[e.keyCode]) {
                    wEditor[oKey[e.keyCode] + 'Key'] = true;
                    console.log(oKey[e.keyCode] + 'Key = true');
                }
                if (RVwys.ctrlKey && e.keyCode == 89) {
                    RVwys.history.redo();
                    return false;
                }
                if (RVwys.ctrlKey && e.keyCode == 90) {
                    RVwys.history.undo();
                    return false;
                }
                //fo.RVwys.history.add();
                if (navigator.platform.toLowerCase() != 'macintel') {
                    RVwys.history.keycode(e);
                }
            })
            .keyup(function (e) {
                wEditor.currentEditor = RVwys.document
                    ? RVwys.document
                    : document;
                //console.log(e.keyCode);
                var curRange = $(e.target);
                const editEvent = curRange.attr('data-w:' + e.type);
                if (!RVwys.wysAction(e, editEvent)) {
                    return false;
                }
                if (oKey[e.keyCode]) {
                    wEditor[oKey[e.keyCode] + 'Key'] = false;
                    console.log(oKey[e.keyCode] + 'Key = false');
                }
            })
            .mousedown(function (e) {
                /*form editor*/

                parent.$('.wys-panel:not([cmd=stay])').hide();
                $('.insertElement,.insertBlock,.insetrSection').hide();
                $('.savewidget').show();
                /*image editor*/
                parent.clickFromEdit = false;

                if ($(this).find('.cropper-view-box').get(0)) {
                    console.log('mode edit image');
                    return false;
                }
                var curRange = $(e.target);
                console.log('has curRange.attr("data-w:mousedown")');
                console.log(curRange.attr('data-w:mousedown'));
                const editEvent = curRange.attr('data-w:mousedown');
                if (!RVwys.wysAction(e, editEvent)) {
                    return false;
                }
                console.log(curRange.get(0).tagName + '-->tring');
                parent.dynamicLock = parent.$('.icon-lock').get(0)
                    ? true
                    : false;

                //parent.$('.blockEditableTools').show();
                //parent.$('.accordion-panel').accordion( "option", "active", 0 );

                if (themeName == 'uikit') {
                    RVwys.uikit.blockprop.eventEditFocus($(this));
                }

                parent
                    .$('#text')
                    .html(
                        'pageX: ' +
                            e.pageX +
                            ', pageY: ' +
                            e.pageY +
                            'scroll Height' +
                            window.scrollY
                    );
                var designX = -150;
                var designY = -20;
                var mmX = e.pageX - window.scrollX + designX;
                var mmY = e.pageY - window.scrollY + designY;
                var mleft = mmX + parent.$('.wys-dynamic').width();
                var mleft =
                    mleft > parent.$(window).width()
                        ? mmX - (mleft - parent.$(window).width())
                        : mmX;
                console.log('mousedown dynamicLock' + parent.dynamicLock);

                // image namager focus

                if (curRange.get(0).tagName == 'IMG' || isResize) {
                    var managerLeft =
                        curRange.position().left +
                        curRange.width() -
                        window.scrollX;
                    var managerTop = mmY;
                } else {
                    var managerLeft = mleft;
                    var managerTop = mmY;
                }

                parent.$('dl dd ul').hide();
                wEditor.currentEditor = RVwys.document
                    ? RVwys.document
                    : document;
                var tag = curRange.get(0).tagName.toLowerCase();
                if (tag != 'button' && curRange.get(0).className != 'wgetAll') {
                    $('.wgetAll').remove();
                }
                RVwys.swDyamicToolbar(curRange);
                var isResize =
                    curRange.get(0).id == 'borderResize' ? true : false;
                var isResizeCss = curRange
                    .get(0)
                    .className.match(/(?:pointBlock|imgEditor)/gim);
                if (!isResize && !isResizeCss) {
                    $('.layoutResize').remove();
                    RVwys.isTagImage = false;
                }
                //        }
            })
            .mouseup(function (e) {
                //alert('mouseup')
                //block tools
                console.log('mouseup ---------------->');
                console.log($(e.target).get(0).className);

                var curRange = $(e.target);

                //parent.$( ".background-prop" ).tabs( "enable", 0 );
                //alert(parent.$('.tpl-blocktoolbars').html())
                const editEvent = curRange.attr('data-w:' + e.type);
                if (!RVwys.wysAction(e, editEvent)) {
                    return false;
                }
                if (!parent.editorImage && parent.nviActive) {
                    //alert('editorImage')
                    RVwys.fixBlockTools();
                    var UKWidth = $(RVwys.currentiFrame).closest(
                        'div[class*=uk-width]'
                    );
                    UKWidth.css('position', 'relative');

                    UKWidth.append(
                        $(parent.$('.tpl-blocktoolbars').html())
                            .find('.cloneBlock')
                            .click(function () {
                                RVwys.removePreviewWidget();
                                var oForm = $(this).closest('.uk-form');
                                //alert('ss')

                                var blockClone = $(this)
                                    .parent()
                                    .parent()
                                    .clone();
                                blockClone.find('.blockTools').remove();

                                if (oForm.get(0)) {
                                    blockClone
                                        .find('input,textarea,select')
                                        .unbind('mousedown')
                                        .mousedown(function () {
                                            RVwys.uikit.formInputMousedown(
                                                $(this)
                                            );
                                        });
                                    var m = new Date().getTime();
                                    blockClone
                                        .find(
                                            '[id^=rv-field-design],[id^=rv-form-design],[id^=rv-field-multi-design],[id^=rv-form-multi-design]'
                                        )
                                        .each(function () {
                                            $(this).attr({
                                                id: $(this).attr('id') + m,
                                                //,'name':$(this).attr('name')+m
                                            });
                                        });
                                }

                                $(this).parent().parent().after(blockClone);
                                blockClone
                                    .find('.RVWYSIWYGAREA')
                                    .each(function () {
                                        var id =
                                            $(this).attr('id') +
                                            $(this).index();
                                        $(this).attr('id', id);
                                        var testEditor = RVwys.EditorByClass(
                                            '#' + id,
                                            true
                                        );
                                    })
                                    .eq(0)
                                    .focus();
                            })
                            .end()
                            .find('.removeBlock')
                            .click(function () {
                                RVwys.removePreviewWidget();
                                var oForm = $(this).closest('.uk-form');
                                $(this).parent().parent().remove();
                                setTimeout(function () {
                                    RVwys.uikit.checkEmail(oForm);
                                }, 50);

                                if (
                                    $(this).parent().parent().find('img').get(0)
                                ) {
                                    $('.image-editor-tool').hide();
                                }
                            })
                            .end()
                            .find('.blockAnimation')
                            .click(function () {
                                //alert('ss')
                                RVwys.removePreviewWidget();
                                RVwys.uikit.blockprop.blockAnimation();
                            })
                            .end()
                            .find('.parallaxBlock')
                            .click(function () {
                                RVwys.removePreviewWidget();
                                RVwys.uikit.blockprop.blockParallax();
                            })
                            .end()
                            .css('position', 'absolute')
                    );
                }
                //$(RVwys.currentiFrame).closest('div[class*=uk-width]').css({
                //end block tools
                $(RVwys.currentiFrame).css({ cursor: '' });
                parent.breakEvent = true;
                //RVwys.fixBlockTools();
                var curRange = $(e.target);
                var tag = curRange.get(0).tagName.toLowerCase();
                var isResize =
                    curRange.get(0).id == 'borderResize' ? true : false;
                var tagClass = RVwys.aSwitchTag[tag]
                    ? RVwys.aSwitchTag[tag]
                    : '.dtbartext';
                switch (tag) {
                    case 'img':
                    case 'video':
                    case 'object':
                    case 'canvas':
                    case 'iframe':
                        RVwys.isTagImage = curRange.get(0);
                        curImage = curRange;
                        parent.curImage = curRange;
                        var sel = RVwys.currentEditor.getSelection();
                        var newSel = RVwys.currentEditor.createRange();
                        sel.removeAllRanges();
                        newSel.selectNode(curRange.get(0));
                        sel.addRange(newSel);
                        if (
                            !RVwys.isTagImage.className.match(
                                /(jotForm|fbComment|fbpageplugin|fbLikebox|fbLikebutton|imgFacebookLike|imgFacebookComment|imgFacebookPage|php|script|style|video_youtube|insertwidget)/gim
                            )
                        ) {
                            imageCur = curRange;
                            curRange.resizeImage();
                        }
                        $(RVwys.currentiFrame).focus();
                        RVwys.history.pre(e);
                        break;
                    default:
                        var range = RVwys.getRange();
                        if (range != '') {
                            RVwys.history.pre(e);
                        } else {
                            RVwys.history.preLevel = false;
                        }
                        break;
                }
                /*
            if($.browser.webkit) {
                switch (tag) {
                case 'img':
                case 'video':
                case 'object':
                case 'canvas':
                case 'iframe':
                    RVwys.isTagImage = curRange.get(0);
                    curImage = curRange;
                    parent.curImage = curRange;
                    var sel = RVwys.currentEditor.getSelection();
                    var newSel = RVwys.currentEditor.createRange();
                    sel.removeAllRanges();
                    newSel.selectNode(curRange.get(0));
                    sel.addRange(newSel);
                    if (!RVwys.isTagImage.className.match(/(jotForm|fbComment|fbpageplugin|fbLikebox|fbLikebutton|imgFacebookLike|imgFacebookComment|imgFacebookPage|php|script|style|video_youtube)/img)) {
                    	imageCur = curRange;
                    	curRange.resizeImage();
                    }
                    $(RVwys.currentiFrame).focus();
                    RVwys.history.pre(e);
                break;
                default:
                    var range = RVwys.getRange();
                if (range != '') {
                    RVwys.history.pre(e);
                } else {
                    RVwys.history.preLevel = false;
                }
                break;
                }
            }else {
                var range = RVwys.getRange();
                if (range != '') {
                    RVwys.history.pre(e);
                } else {
                    RVwys.history.preLevel = false;
                }
            }
            */
                RVwys.eventDynamictoolsbarMouseUp(tagClass);
            })
            .on('paste', function (e) {
                if (parent.handlepaste) {
                    parent.handlepaste($(this).get(0), e);
                } else {
                    handlepaste($(this).get(0), e);
                }

                // RVwys.history.add();
            })
            .each(function (i, ui) {
                if ($(this).html() == '' || $(this).html() == ' ') {
                    // $(this).html('&nbsp;')
                }
                wEditor.aTarget[i] = $(this);
                if ($.colorbox) {
                    $.colorbox.remove();
                }
                $(this).get(0).contentEditable = 'true';
                $(this).get(0).designMode = 'On';
                $(this).addClass('editorCurrent');
                $(this).placeHoldersRaw();
                wEditor.runEvents_DesignView($(this));
            });

        $('focus').remove();
        $('endfocus').remove();
        if (!isFocus) {
            $('.editorCurrent').eq(0).focus();
        }
        return wEditor;
    };
    RVwys.wysAction = function (e, editEvent) {
        console.log('wysAction');
        console.log(e.type);
        var eventAct = editEvent + ':' + e.type;
        switch (editEvent) {
            case undefined:
            case '':
            case 'true':
            case null:
            case 'null':
                break;
            case 'false':
                e.stopImmediatePropagation(); // stop event all
                e.preventDefault();
                return false;
            default:
                e.stopImmediatePropagation(); // stop event all
                e.preventDefault();
                console.log('asdfsd');
                if (RVwys.oEventsDesignViewByWidget[eventAct]) {
                    RVwys.oEventsDesignViewByWidget[eventAct]['func'](e);
                }
                return false;
        }
        return true;
    };
    RVwys.startBlockTools = function () {
        $('.mg')
            .find('.uk-container > .uk-grid > div[class*=uk-width]')

            .each(function () {
                var res = $(this).get(0).className;
                var s = res.replace(
                    /uk\-width\-(?:(?:small|medium|large)\-)?([0-9]\-[0-9]).*/,
                    function (m, i) {
                        return i;
                    }
                );
                $(this).css({
                    position: 'relative',
                });
                $(this).append(
                    $(
                        '<div class="blockTools" style="display:none;">' +
                            s +
                            '<i class="uk-icon-times uk-icon-small"></i></div>'
                    ).click(function () {
                        //$(this).parent().remove();
                    })
                );
            });
        RVwys.UIgridSortable();
    };

    RVwys.UIgridSortable = function (obj) {
        //alert('s')

        var thisObj = obj ? obj : $('.mg');
        var isForm = thisObj.find('.uk-form').get(0) ? true : false;
        var isAxis = isForm ? 'y' : null;
        thisObj.find('.uk-grid').sortable({
            handle: '.tpl-blockmove',
            // items: "li:not(.ui-state-disabled)"
            // connectWith:'.mg .uk-grid',
            opacity: '.5',
            //handle:".handledMove",
            axis: isAxis,
            placeholder: {
                element: function (e, li) {
                    var groupPHB = $(e).get(0).className;
                    console.log(
                        'tpl-block-placeholder->' +
                            groupPHB +
                            'height->' +
                            $(this).height()
                    );
                    var phd = $(
                        $('.tpl-block-placeholder')
                            .html()
                            .replace(/ui-placeholder-block/i, groupPHB)
                        //.replace(/height\:auto\;/i,'height:'+$(this).height()+'px')
                    );
                    return phd[0];
                    //tpl-placeholder
                },
                update: function (e, li) {
                    return;
                },
            },
            start: function (e, ui) {
                RVwys.removePreviewWidget();
                $(this).addClass('placeholder-drag');
                isForm = $(this).parent().hasClass('uk-form') ? true : false;
                console.log('formsssss' + isForm);
                if (isForm) {
                    thisObj.find('[class*=uk-width]').css({
                        transition: 'transform .2s',
                        left: '',
                    });
                    var startIndex = ui.placeholder.index();
                    uiHeight = ui.item.outerHeight(true);
                    ui.item
                        .nextAll('[class*=uk-width]:not(.placeholder-block)')
                        .css({
                            transform: 'translateY(' + uiHeight + 'px)',
                        });

                    ui.placeholder.css({
                        height: 0,
                        padding: 0,
                    });
                }
            },
            stop: function (e, ui) {
                isForm = $(this).parent().hasClass('uk-form') ? true : false;
                $(this).removeClass('placeholder-drag');
                if (isForm) {
                    thisObj.find('[class*=uk-width]').css({
                        transform: 'translateY(0)',
                    });
                }

                thisObj.find('[class*=uk-width]').css({
                    transition: '',
                });
            },
            change: function (e, ui) {
                if (isForm) {
                    var changeIndex = ui.placeholder.index();
                    if (startIndex > changeIndex) {
                        var slice = thisObj
                            .find('[class*=uk-width]')
                            .slice(
                                changeIndex,
                                thisObj.find('[class*=uk-width]').length
                            );

                        slice.not('.ui-sortable-helper').each(function () {
                            var item = $(this);
                            item.css({
                                transform: 'translateY(' + uiHeight + 'px)',
                            });
                        });
                    } else if (startIndex < changeIndex) {
                        var slice = thisObj
                            .find('[class*=uk-width]')
                            .slice(startIndex, changeIndex);

                        slice.not('.ui-sortable-helper').each(function () {
                            var item = $(this);
                            item.css({
                                transform: 'translateY(0px)',
                            });
                        });
                    }

                    startIndex = changeIndex;
                }
            },
            receive: function (e, ui) {
                ui.sender.data('copied', true);
                var bms = $('#blockMainSetting');
                var isForm = false;
                var matchClassRV = ui.item
                    .attr('data')
                    .match(
                        /rv-field-design|rv-field-multi-design|rv-form-panel/gim
                    );
                if (matchClassRV) {
                    isForm = true;
                    var data = ui.item
                        .attr('data')
                        .replace(
                            /rv-field-design/gim,
                            `rv-field-design${$.now()}`
                        );
                    data = data.replace(
                        /rv-field-multi-design/gim,
                        function (m) {
                            return `rv-field-multi-design${new Date().getTime()}${i++}`;
                        }
                    );
                    ui.item.replaceWith(data);
                } else {
                    ui.item.replaceWith(
                        '<div class="mg">' + ui.item.attr('data') + '</div>'
                    );
                }
                setTimeout(function () {
                    var i = 0;
                    var id;
                    $('.editable_area')
                        .find("div[contenteditable='true']")
                        .each(function () {
                            if (!$(this).hasClass('RVWYSIWYGAREA')) {
                                var rvsb_design_block = RVwys.getParentByClass(
                                    $(this),
                                    'rvsb_design_block'
                                );
                                if (
                                    !rvsb_design_block
                                        .find('.navMenu-blockMainSetting')
                                        .get(0)
                                ) {
                                    rvsb_design_block.prepend(bms.html());
                                }
                                if (isForm) {
                                    rvsb_design_block
                                        .find('.handledClone')
                                        .remove();
                                    $(this).addClass('formEditable');
                                }
                                var idpref = $.md5(String(e.timeStamp));
                                id = 'editable_area_custom' + idpref + i;
                                i++;
                                $(this)
                                    .attr({
                                        id: id,
                                        'data-ph':
                                            'Editable Area. Backspace tab to remove this block.',
                                    })
                                    .addClass(
                                        'RVWYSIWYGAREA editorCurrent areaCustom'
                                    );

                                var testEditor = RVwys.EditorByClass(
                                    '#' + id,
                                    'notfocus'
                                );
                                var oMG = $('#' + id).closest('.mg');

                                RVwys.UIgridSortable(oMG);

                                console.log('blocks ' + i + ' load');

                                oMG.mousedown(function (e) {
                                    RVwys.eventClickblock($(this), e);
                                });
                            }
                        });
                    console.log(' total blocks ' + i + ' item');

                    setTimeout(function () {
                        if (id) {
                            var oMG = RVwys.getParentByClass($('#' + id), 'mg');
                            var tFoCus = oMG.find('.editorCurrent').eq(0);
                            $('html, body').animate(
                                {
                                    scrollTop: tFoCus.offset().top,
                                },
                                1000,
                                function () {
                                    tFoCus.get(0).focus();
                                    //RVwys.imageEditorToolResetPos();
                                }
                            );
                            RVwys.currentEditor = document;
                            RVwys.currentiFrame = tFoCus.get(0);
                            RVwys.uikit.blockprop.eventEditFocus(tFoCus);
                        }
                    }, 100);
                }, 500);

                RVwys.imageEditorToolResetPos();
            },
        });
        RVwys.uikit.formReceiEvent(thisObj);
    };

    /*


RVwys.UIgridSortable = function(obj){
	//alert('s')

	var thisObj = (obj) ? obj:$('.mg')
	thisObj.find('.uk-grid').sortable({
  		handle:".tpl-blockmove",
	       // items: "li:not(.ui-state-disabled)"
       // connectWith:'.mg .uk-grid',
	        opacity: '.5',
	        //handle:".handledMove",
	       //axis:"x",
	        placeholder: {
             element: function(e, li) {
             	var groupPHB = $(e).get(0).className;
             	console.log('tpl-block-placeholder->'+groupPHB+'height->'+$(this).height())
            	var phd =  $($('.tpl-block-placeholder').html()
            			.replace(/ui-placeholder-block/i,groupPHB)
            			//.replace(/height\:auto\;/i,'height:'+$(this).height()+'px')
            			);
             	return phd[0];
             	//tpl-placeholder
             },
             update: function(e, li) {
                 return;
             }
         },
         start:function(e,ui){
       	  $(this).addClass('placeholder-drag')
         },
         stop:function(e,ui) {

           	  $(this).removeClass('placeholder-drag')

         },
	       receive: function (e, ui) {
	        	if ($(ui.item).attr('widget')) {
	        		if (RVwys.widget[$(ui.item).attr('widget')]) {
	        			RVwys.widget[$(ui.item).attr('widget')].sectionReceive(this,e,ui);
	        		}
	        		//RVwys.imageEditorToolResetPos();
	        	} else {
	        		ui.sender.data('copied', true);
	        		var bms = $('#blockMainSetting');
	        		ui.item.replaceWith(ui.item.attr('data'));
	        		$(this).parent().find('.dropHere').remove();

	        		}
	        	RVwys.imageEditorToolResetPos();
	        }

	});
	thisObj.find('.uk-form').unbind( "click" ).click(function(){
		$('.forms-sortable').hide();
		$('forms-item-sortable').show();
	})
}

*/

    RVwys.fixBlockTools = function () {
        //alert('fixBlockTools')

        $('.blockTools')
            .not($('.tpl-blocktoolbars').find('.blockTools'))
            .remove();
        $('.mg')
            .find('.uk-container > .uk-grid')
            .find('[class*=uk-width]')
            .each(function () {
                $(this).css({ position: '' });
            });
        //fix layout image editor for block overlab.
    };

    RVwys.fixBlockToolsRelative = function () {
        //alert('fixBlockTools')
        $('.blockTools').remove();
        $('.mg')
            .find('.uk-container > .uk-grid')
            .find('[class*=uk-width]')
            .each(function () {
                $(this).css({ position: 'relative' });
            });
    };

    RVwys.EditorByUIkit = function (isEditPage) {
        RVwys.EffPlaceholder = 'placeholder';
        $('[srcs]').each(function () {
            $(this).attr('src', $(this).attr('srcs'));
        });
        if (!$('.design-block').get(0)) {
            setTimeout(function () {
                RVwys.EditorByUIkit();
            }, 500);
        } else {
            $('.design-block')
                .find('.editable_area')
                .each(function () {
                    if (!$(this).hasClass('designBlock')) {
                        $(this).addClass('designBlock');
                    }
                    var thisBlockMain = $('#blockMainSetting').html();
                    var mgSet = $(this).find('.rvsb_design_block');
                    mgSet.each(function () {
                        if (!$(this).hasClass('mgwidget')) {
                            //	$(this).prepend(thisblockSub);
                            $(this).prepend(thisBlockMain);
                        }
                    });
                });

            RVwys.uikit.loadSectionDesign(isEditPage);

            RVwys.uikit.layoutBorder();
            $("li[aria-controls='sidebarTabsSidebar']").hide();
            parent
                .$('.dynamic-lock')
                .unbind('click')
                .click(function () {
                    if ($(this).hasClass('icon-unlock')) {
                        $(this)
                            .addClass('icon-lock')
                            .removeClass('icon-unlock');
                        parent.dynamicLock = true;
                    } else {
                        $(this)
                            .addClass('icon-unlock')
                            .removeClass('icon-lock');
                        parent.dynamicLock = false;
                    }
                });

            parent
                .$('.dynamic-showhide')
                .unbind('click')
                .click(function () {
                    parent.RVwys.hideDynamic();
                });
            parent
                .$('.panel-showhide-tool')
                .unbind('click')
                .click(function () {
                    //alert('close')
                    $(this)
                        .closest('.wys-panel,.wys-panels')
                        .find('.main-panel')
                        .toggle();

                    $('.overlaypanel').remove();
                    parent.$('.overlaypanel').remove();
                });
            parent
                .$('.panel-showhide')
                .unbind('click')
                .click(function () {
                    RVwys.removePreviewWidget();
                    $(this).closest('.wys-panel,.wys-panels').hide();
                    $('.overlaypanel').remove();
                    parent.$('.overlaypanel').remove();
                });

            if (parent.$('.wys-dynamic').data('ui-draggable')) {
                parent.$('.wys-dynamic').draggable('destroy');
            }

            parent.$('.wys-dynamic,.wys-rowTwo').mousedown(function () {
                $(
                    '.image-editor-tool,.icon-widget-preview,.icon-widget-preview'
                ).hide();
            });
            parent.$('.wys-dynamic').draggable({
                handle: '.dynamicMove',
                snap: '#fBody',
                containment: '#fBody',
                scroll: false,
                start: function (event, ui) {
                    var overlaypanel = $(
                        '<div class="overlaypanel"></div>'
                    ).css({
                        opacity: '0.0',
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: $('body').width(),
                        height: $('body').height(),
                    });
                    parent.$('body').prepend(overlaypanel);
                },
                stop: function (event, ui) {
                    parent.$('.overlaypanel').remove();
                },
            });
            var dyW = parent.$('.wys-dynamic').width();

            parent.$('.wys-dynamic').css({
                left: parent.$('body').width() / 2 - dyW / 2,
                top: '80px',
            });
            //parent.$('.accordion-panel').accordion({heightStyle: "content"});
            parent.$('.mode-element').tabs({
                activate: function (event, ui) {
                    var tabNumber = parent
                        .$('.mode-element')
                        .tabs('option', 'active');
                    switch (tabNumber) {
                        case 0:
                            //    alert('s')
                            RVwys.tableText();
                            RVwys.ToolsDefaultImage();
                            break;
                        case 1:
                            //    alert('s1')
                            RVwys.tableCell();
                            break;
                        case 2:
                            RVwys.ShadowImage();
                            break;
                        case 3:
                            RVwys.BorderImage();
                            break;
                        default:
                            break;
                    }
                },
            });

            parent.$('.mode-tabs').tabs();

            //	   parent.$('.wys-rowTwo,.wys-rowThree,.wys-pEffect, .wys-rowFour, .wys-rowHeader, .wys-menuDesign,.wys-navPropertie,.wys-rowTen,.wys-rowFormSeting,.wys-topmenuDesign').draggable({
            parent.$('.wys-panel').draggable({
                handle: '.editormode-status',
                containment: '#fBody',
                snap: '#fBody',
                scroll: false,
                start: function (event, ui) {
                    var overlaypanel = $(
                        '<div class="overlaypanel overlaypanel-d"></div>'
                    ).css({
                        opacity: '0.0',
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: $('body').width(),
                        height: $('body').height(),
                    });
                    parent.$('body').prepend(overlaypanel);
                },
                stop: function (event, ui) {
                    parent.$('.overlaypanel-d').remove();
                },
            });
            // parent.$('.accordion-panel').accordion({heightStyle: "content"});
            parent.$('.imageLib').draggable({
                handle: '.title-ImageManager',
                containment: '#fBody',
                snap: '#fBody',
                scroll: false,
                start: function (event, ui) {
                    var overlaypanel = $(
                        '<div class="overlaypanel"></div>'
                    ).css({
                        'background-color': 'red',
                        opacity: '0.0',
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: $('body').width(),
                        height: $('body').height(),
                    });
                    parent.$('body').prepend(overlaypanel);
                },
                stop: function (event, ui) {
                    parent.$('.overlaypanel').remove();
                },
            });

            $('#image-editor-overlay')
                .click(function (e) {
                    $('.rvCurrentImage').removeClass('rvCurrentImage');
                    parent
                        .$('.imageLib')
                        .find('.rvCurrentImage')
                        .removeClass('rvCurrentImage');
                    if (parent.$('.imageLib').is(':visible')) {
                        curImage.addClass('rvCurrentImage');
                        parent.focusImage = curImage;
                        //current image manager
                        var fullPath = curImage.attr('src');
                        var filename = fullPath.replace(/^.*[\\\/]/, '');
                        var keyName = filename.replace('.', '-dot-');
                        parent
                            .$('.imageLib')
                            .find('#' + keyName)
                            .eq(0)
                            .addClass('rvCurrentImage');
                    }
                })
                .dblclick(function (e) {
                    $(
                        '.image-editor-tool,.image-editor-overlay,.icon-widget-preview'
                    ).hide();
                    RVwys.currentEditor = document;
                    $(RVwys.currentiFrame).off('mouseover', '**');
                    var event = jQuery.Event('mouseup');
                    event.target = parent.focusImage
                        ? parent.focusImage.get(0)
                        : curImage.get(0);
                    RVwys.swDyamicToolbar($(event.target));

                    $(RVwys.currentiFrame).trigger(event);
                });

            parent
                .$('#imageLib-tabs')
                .tabs({
                    active: false,
                    collapsible: true,
                    activate: function (event, ui) {
                        var active = parent
                            .$('#imageLib-tabs')
                            .tabs('option', 'active');
                        var imgUl = parent
                            .$('#imageLib-tabs')
                            .find('ul')
                            .find('li a');
                        var activeTab = imgUl.eq(active).attr('href');
                        parent
                            .$('#imageLib-tabs')
                            .tabs('option', 'collapsible', false);
                        parent.$('.imageBoxView').hide();
                        // alert('active'+active)
                        switch (activeTab) {
                            case '#freeImage':
                                console.log(parent.aFreeImages);
                                parent.$('.imageBoxView-free').show();
                                // parent.$('.imageBoxView-free').html('');
                                if (
                                    parent.$('.imageBoxView-free').html() == ''
                                ) {
                                    RVwys.imagemanager.addView(
                                        parent.aFreeImages,
                                        'all'
                                    );
                                }
                                break;
                            case '#freeBackground':
                                console.log('freeBackground');
                                parent.$('.imageBoxView-background').show();

                                var aFreeBackground =
                                    parent.aFreeBackground.bggroup;
                                RVwys.imagemanager.addTagBackground(
                                    aFreeBackground,
                                    'all'
                                );

                                break;
                            case '#socialImage':
                                //facebook connect
                                parent.$('.imageBoxView-facebook').show();

                                break;
                            case '#myImage':
                                //my image connect
                                parent.$('.imageBoxView-myimage').show();

                                RVwys.loadMyImages();

                                break;
                            default:
                                //
                                break;
                        }
                    },
                })
                .addClass('ui-tabs-vertical ui-helper-clearfix');
            parent
                .$('#imageLib-tabs li')
                .removeClass('ui-corner-top')
                .addClass('ui-corner-left');

            $('#design-sortable,#design-sortable-email')
                .disableSelection()
                .sortable({
                    connectWith: '.designBlock',
                    opacity: '.5',
                    appendTo: 'body',
                    sort: function (e, ui) {
                        RVwys.hidemgActive();
                    },
                    placeholder: {
                        element: function (e, li) {
                            return $($('.tpl-placeholder').html())[0];
                        },
                        update: function (e, li) {
                            console.log(
                                'update image-editor-tool--->' +
                                    parent.$('.image-editor-tool').get(0)
                            );
                            RVwys.imageEditorToolResetPos();
                            return;
                        },
                    },
                    helper: function (e, li) {
                        this.copyHelper = li.clone().insertAfter(li);
                        $(this).data('copied', false);
                        return $('<div class="rvSWDhelper" style=""></div>');
                    },
                    stop: function (event, ui) {
                        var $uiItem = $(ui.item);
                        if ($uiItem.parent().is('#design-sortable'))
                            $uiItem.remove();
                    },
                });

            if ($('.designBlock').data('ui-sortable')) {
                $('.designBlock').sortable('destroy');
            }

            $('.sectionDesign').click(function () {
                RVwys.hidemgActive();
                //RVwys.UIgridSortable();
                //RVwys.fixBlockTools();
                //RVwys.startBlockTools();
            });

            $('.mg').mousedown(function (e) {
                RVwys.CurrentSection($(this));
                RVwys.eventClickblock($(this), e);
            });

            RVwys.UIgridSortable();

            $('.designBlock').sortable({
                opacity: '.5',
                handle: '.handledMove',
                axis: 'y',
                placeholder: {
                    element: function (e, li) {
                        //console.log('rowfull-->'+parent.$('#rowfull').prop( "checked" )+ ' bg->'+parent.$('#set-rowProperties').spectrum('get'))
                        if (parent.$('#rowfull').prop('checked')) {
                            //alert('fff')
                            $(
                                '.tpl-placeholder  > .mg  > .uk-container-center'
                            ).addClass('rv-block-full');
                        } else {
                            $(
                                '.tpl-placeholder  > .mg  > .uk-container-center'
                            ).removeClass('rv-block-full');
                        }

                        return $($('.tpl-placeholder').html())[0];
                        //tpl-placeholder
                    },
                    update: function (e, li) {
                        return;
                    },
                },
                receive: function (e, ui) {
                    parent.$('.wys-panel').hide();
                    console.log('receive widget');
                    console.log($(ui.item).get(0));
                    if ($(ui.item).attr('widget')) {
                        if (
                            RVwys.widget[$(ui.item).attr('widget')] &&
                            $.isFunction(
                                RVwys.widget[$(ui.item).attr('widget')]
                                    .sectionReceive
                            )
                        ) {
                            RVwys.widget[
                                $(ui.item).attr('widget')
                            ].sectionReceive(this, e, ui);
                            // RVwys.widget[$(ui.item).attr('widget')].sectionReceive(this,e,ui);
                        } else {
                            RVwys.widget.sectionReceive(this, e, ui.item);
                        }
                        //RVwys.imageEditorToolResetPos();
                        return;
                    }
                    if ($(ui.item).attr('data-appname')) {
                        if (
                            RVwys.widget[$(ui.item).attr('data-appname')] &&
                            $.isFunction(
                                RVwys.widget[$(ui.item).attr('data-appname')]
                                    .sectionReceive
                            )
                        ) {
                            RVwys.widget[
                                $(ui.item).attr('data-appname')
                            ].sectionReceive(this, e, ui);
                            // RVwys.widget[$(ui.item).attr('widget')].sectionReceive(this,e,ui);
                        } else {
                            RVwys.widget.sectionReceive(this, e, ui.item);
                        }
                        //RVwys.imageEditorToolResetPos();
                        return;
                    }

                    ui.sender.data('copied', true);
                    var bms = $('#blockMainSetting');
                    var formMasterId = ui.item.attr('form');
                    if (formMasterId) {
                        var newId = formMasterId + $.now();
                        var regex2 = new RegExp(formMasterId, 'img');
                        var data = ui.item.attr('data').replace(regex2, newId);
                        data = data.replace(
                            /rv-field-design/gim,
                            'rv-field-design' + $.now()
                        );
                        i = 0;
                        data = data.replace(
                            /rv-form-multi-design/gim,
                            function (m) {
                                return (
                                    'rv-form-multi-design' +
                                    new Date().getTime() +
                                    i++
                                );
                            }
                        );
                    } else {
                        var data = ui.item.attr('data');
                    }
                    var repl = $('<div class="mg">' + data + '</div>');
                    ui.item.replaceWith(repl);
                    $(this).parent().find('.dropHere').remove();
                    //RVwys.imageEditorToolResetPos();
                    //alert(repl.find('.uk-form').get(0))
                    var isFormAll = repl.find('.uk-form').get(0) ? true : false;
                    if (isFormAll) {
                        var fm = repl.find('.uk-form');
                        parent.oFormUIKIT = fm;
                        RVwys.uikit.htmlThankForm(fm);
                        RVwys.uikit.formDefaultEmail(fm);

                        RVwys.uikit.formAPIAdd(fm);
                    }
                    var formsProp = $('.formsProp').clone();

                    setTimeout(function () {
                        var i = 0;
                        var id;
                        $('.editable_area')
                            .find("div[contenteditable='true']")
                            .each(function () {
                                if (!$(this).hasClass('RVWYSIWYGAREA')) {
                                    var rvsb_design_block = RVwys.getParentByClass(
                                        $(this),
                                        'rvsb_design_block'
                                    );
                                    if (
                                        !rvsb_design_block
                                            .find('.navMenu-blockMainSetting')
                                            .get(0)
                                    ) {
                                        rvsb_design_block.prepend(bms.html());
                                        var isForm = rvsb_design_block
                                            .find('.uk-form')
                                            .get(0)
                                            ? true
                                            : false;
                                        if (isForm) {
                                            rvsb_design_block.prepend(
                                                formsProp
                                            );
                                            RVwys.uikit.panelFormDesign(
                                                rvsb_design_block.find(
                                                    '.uk-form'
                                                )
                                            );
                                        }
                                    }

                                    if (isFormAll) {
                                        rvsb_design_block
                                            .find('.handledClone')
                                            .remove();
                                        $(this).addClass('formEditable');
                                    }
                                    var idpref = $.md5(String(e.timeStamp));
                                    id = 'editable_area_custom' + idpref + i;
                                    //console.log('id--->'+id)
                                    i++;
                                    $(this)
                                        .attr({
                                            id: id,
                                            'data-ph':
                                                'Editable Area. Backspace tab to remove this block.',
                                        })
                                        .addClass(
                                            'RVWYSIWYGAREA editorCurrent areaCustom'
                                        );

                                    var testEditor = RVwys.EditorByClass(
                                        '#' + id,
                                        'notfocus'
                                    );
                                    var oMG = $('#' + id).closest('.mg');

                                    RVwys.UIgridSortable(oMG);

                                    console.log('blocks ' + i + ' load');

                                    oMG.mousedown(function (e) {
                                        RVwys.eventClickblock($(this), e);
                                    });
                                }
                            });
                        console.log(' total blocks ' + i + ' item');

                        setTimeout(
                            function () {
                                if (id != '') {
                                    var oMG = $('#' + id).closest('.mg');
                                    var tFoCus = oMG
                                        .find('.editorCurrent')
                                        .eq(0);
                                    $('html, body').animate(
                                        {
                                            scrollTop: tFoCus.offset().top,
                                        },
                                        1000,
                                        function () {
                                            tFoCus.get(0).focus();
                                            //RVwys.imageEditorToolResetPos();
                                        }
                                    );
                                    RVwys.currentEditor = document;
                                    RVwys.currentiFrame = tFoCus.get(0);
                                    RVwys.uikit.blockprop.eventEditFocus(
                                        tFoCus
                                    );
                                }
                            },
                            100,
                            id
                        );
                    }, 500);
                    RVwys.imageEditorToolResetPos();
                },
                start: function (e, li) {
                    RVwys.removePreviewWidget();
                },
                helper: function (e, li) {
                    return $($('.tpl-helper').html())[0];
                    //return $('<div class="rvSWDhelper" style="width:'+$(this).width()+'px;height:20px;border:solid 3px #fcfcfc;"></div>');
                },
            });
        }
    };

    RVwys.EditorByClass = function (jObj, isFocus) {
        var oTargetObj;
        if (jObj) {
            oTargetObj = jObj;
        } else {
            oTargetObj = RVwys.opts.target;
            this.loadToolbar();
        }
        console.log('------>EditorByClass');
        RVwys.EditorAddEvent(oTargetObj, isFocus);
        return RVwys;
    };
    RVwys.tableSelect = function (obj) {
        obj.find('table')
            .bind('mousedown', function (e) {
                $(this).find('td').attr('bgcolor', '');
                if ($(e.target).get(0).tagName.toLowerCase() == 'td') {
                    $(e.target).attr('bgcolor', 'blue');
                    indextr = $(e.target).parent().index();
                    indextd = $(e.target).index();
                }
                $(this).bind('mouseover', function (e) {
                    if ($(e.target).get(0).tagName.toLowerCase() == 'td') {
                        oTR = $(e.target).parent();
                        oTD = $(e.target);
                        g = Math.abs(indextr - oTR.index()) + 1;
                        //$('#mouseXY').html(indextr +'-'+ oTR.index()+'='+g+oTR.get(0).tagName+''+oTR.index() +','+indextr);
                        if (oTR.index() != indextr) {
                            $(this)
                                .find('tr')
                                .eq(oTR.index())
                                .find('td')
                                .eq(oTD.index())
                                .attr('bgcolor', 'blue');
                        }
                        var sel = RVwys.currentEditor.getSelection();
                        sel.removeAllRanges();
                        var newSel = RVwys.currentEditor.createRange();
                        newSel.setStartBefore($(e.target).get(0));
                        sel.addRange(newSel);
                        $(e.target).attr('bgcolor', 'blue');
                    }
                });
            })
            .mouseup(function (e) {
                $(this).unbind('mouseover');
            });
    };
    RVwys.selectWidGetByID = function (id) {
        if (id) {
            if ($('#' + id).get(0)) {
                var sel = this.currentEditor.getSelection();
                range = RVwys.currentEditor.createRange();
                sel.removeAllRanges();
                range.selectNode($('#' + id).get(0));
                sel.addRange(range);
            }
        }
    };
    RVwys.removeWidGetButton = function () {
        $('.wgetAll').remove();
    };
    RVwys.setFocus = function () {
        var oThis = this;
        $(this.currentEditor)
            .find('body')
            .find('.img_noneEditor')
            .remove()
            .end()
            .each(function () {
                var aNoneEditor = $(oThis.currentEditor)
                    .find('body')
                    .find('.noneEditor');
                aNoneEditor.each(function () {
                    img =
                        '<img style="position:absolute;" class="img_noneEditor" src="' +
                        oThis.baseUrl +
                        '/theme/default/images/960x300.gif" alt="" width="' +
                        $(this).width() +
                        '" height="' +
                        $(this).height() +
                        '" />';
                    $(this).css({ visibility: 'hidden' }).before(img);
                });
            });
    };
    RVwys.setBlur = function () {
        var aNoneEditor = $(this.currentEditor)
            .find('body')
            .find('.noneEditor');
        $(this.currentEditor).find('body').find('.img_noneEditor').remove();
        aNoneEditor.each(function () {
            $(this).css({ visibility: 'visible' });
        });
    };
    RVwys.swDyamicToolbar = function (eleTarget) {
        if (parent.$('.imageLib').is(':visible')) {
            parent.$('.wys-dynamic').hide();
        }
        var curRange = eleTarget;
        var tag = curRange.get(0).tagName.toLowerCase();
        console.log(tag + '-->' + curRange.get(0).id);
        var isResize = curRange.get(0).id == 'borderResize' ? true : false;
        var isSelectMode = curRange.hasClass('ui-selectee');
        if (!isSelectMode) {
            isSelectMode = curRange.hasClass('ui-selectable');
        }
        if (!isSelectMode) {
            isSelectMode = curRange.hasClass('ui-selecting');
        }

        var isSortMode = curRange.hasClass('moveBlock');
        var isResizeTable = curRange.hasClass('ui-resizable-handle');
        var isPointBlock = curRange.hasClass('pointBlock');
        var isPointImgEditor = curRange.hasClass('imgEditor');
        parent
            .$(
                '.dtbartext,.dtbarimage,.dtbartable,.dtbartablecellprop,.widget-blocks'
            )
            .hide();
        parent.$('.dtbartablecellprop').hide();
        var tagClass = RVwys.aSwitchTag[tag]
            ? RVwys.aSwitchTag[tag]
            : '.dtbartext';
        console.log('parent.tableMode-->' + parent.tableMode);
        console.log('tableMode-->' + parent.tableMode);
        tagClass = parent.tableMode ? '.dtbartable' : tagClass;
        if (
            curRange
                .get(0)
                .className.match(
                    /(jotForm|fbComment|fbLikebox|fbpageplugin|fbLikebutton|imgFacebookLike|imgFacebookComment|imgFacebookPage|php|script|style|dtbartable|video_youtube|insertwidget)/gim
                )
        ) {
            tagClass = '.dtbartext';
        }
        if (isResizeTable) {
            tagClass = '.dtbartable';
            //tagClass = '.dtbartext';
        }
        if (isResize || isPointBlock || isPointImgEditor) {
            tagClass = '.dtbarimage';
        }
        console.log('isResize -->' + tagClass);
        if (curRange.attr('activeTag') == 'object') {
            tagClass = '.dtbartext';
        }
        parent.$(tagClass + ',.mode-element').show();
        //event dynamictools

        RVwys.eventDynamictoolsbarMouseDown(tagClass);
        console.log('selectmode--->' + tagClass);
        //                alert('ss')
        if (tagClass == '.dtbartable') {
            console.log(
                'isSelectMode || isSortMode || isResizeTable' +
                    isSelectMode +
                    isSortMode +
                    isResizeTable
            );
            console.log('tableMode = ' + tableMode);

            parent.$('.tableTextMode').toggle(tableMode);
            parent.$('.tableprop').toggle(!tableMode);
            parent.$('.dtbartableprop').toggle(!tableMode);
            parent.$('.dtbartableCell').toggle(!tableMode);
            parent.$('.dtbartext').toggle(!isSelectMode).toggle(!tableMode);

            if (tableMode) {
                if (isSelectMode || isResizeTable) {
                    parent.$('.dtbartext').hide();
                }
                parent.$('.dtbartablecellprop').show();
            }
        } else {
            parent.$('.mode-element').tabs('option', 'active', 0);
            var curClass = RVwys.getParentByClass(curRange, 'editorCurrent');
            RVwys.unsetTableMode(curClass);
            if (!curRange.hasClass('ui-resizable-handle')) {
                if ($('.ui-selectable').get(0)) {
                    parent.$('#tableTextMode').trigger('click');
                    $(RVwys.currentiFrame)
                        .find('.ui-selected,.ui-selecting')
                        .each(function () {
                            $(this).css({ 'background-color': '' });
                        });
                }
                if (tagClass == '.dtbarimage') {
                    parent.$('.tableprop').hide();
                    parent.$('.dtbartext').hide();
                }
            }
        }

        parent.$('.dtbarCommon').show();
    };
    RVwys.disabledPlugin = function (ui) {
        ui.find('.wys-mastertemplate').hide();
    };

    RVwys.regisEventOnRightBar = function () {
        $('.leftMenu').click(function () {
            //rightBarActive = true;

            $('.leftMenu-hover').removeClass('leftMenu-hover');
            $(this).addClass('leftMenu-hover');
            console.log($(this).parent().find('.menuLeftOver').length);

            //Click leftMenu: Hide: image-editor-tool: apiruk
            //console.log('Click leftMenu: Hide: image-editor-tool');
            //$('.image-editor-tool').hide();

            if ($(this).parent().find('.menuLeftOver').length == 1) {
                $('.menuLeftOver').removeClass('menuLeftOver', function () {
                    $(this).addClass('menuLeftOut');
                });
            } else {
                $('.menuLeftOver').removeClass('menuLeftOver', function () {
                    $(this).addClass('menuLeftOut');
                });

                $(this)
                    .parent()
                    .find('div')
                    .eq(0)
                    .removeClass('menuLeftOut', function () {
                        $(this).addClass('menuLeftOver');
                    });
            }
        });

        // Start Active Category Section name
        $('.category-section-name .section-name').click(function () {
            $('.section-name').removeClass('active-section-name');
            $(this).addClass('active-section-name');
            console.log($(this).parent().find('.section-name').length);
        });
        // End Active Category Section name

        $('a:not([target]').each(function () {
            var href = $(this).attr('href') ? $(this).attr('href') : '';
            if (href.search('javascript') == -1) {
                $(this).attr('target', '_parent');
            }
        });

        $('#sitemapFooter')
            .find('a')
            .attr('onclick', 'return RVwys.linkPOPUP(this);');
        $('[nosubmit]').submit(function (e) {
            return false;
        });
        $('forms').submit(function (e) {
            return false;
        });
        $('.uk-form-system').submit(function (e) {
            return false;
        });
        $('[widgetlink="1"]').click(function (e) {
            if ($(this).attr('nowidget') != undefined) return false;
            if ($(this).parent().parent().hasClass('pagination')) return false;
            $('.linkToolEditable').show();
            $('.linkToolEditable')
                .find('.linkToEdit')
                .hide()
                .end()
                .find('.linkToRemove')
                .hide()
                .end()
                .find('.buttonToClipboard')
                .hide()
                .end()
                .find('.buttonToEdit')
                .hide()
                .end();

            var h = $(this).attr('href') || '';

            h = h.replace(parent.wex.url.baseUrl, parent.wex.url.WYS_SHOW_URL);
            var oLinkk = $(
                '<a href="' +
                    h +
                    '"> <i class="uk-icon-external-link"></i>  ' +
                    h +
                    '</a>'
            );
            if (!h.match(/^\#/)) {
                oLinkk.attr('target', '_blank');
            }
            $('.linkTo').html(oLinkk);
            $('.linkToolEditable').css({
                left: $(this).offset().left,
                top: $(this).offset().top,
            });
            return false;
        });

        //$('a').click(function(){return false;});
        $('#jumpmenu')
            .attr('onchange', '')
            .change(function () {
                return false;
            });

        $('.tabs-ui-content').hover(
            function () {
                $(this).css({ 'overflow-y': 'auto' });
                $(this).focus();
            },
            function () {
                $(this).css({ 'overflow-y': 'hidden' });
            }
        );
    };

    RVwys.linkPOPUP = function (othis) {
        if ($(this).attr('nowidget') != undefined) return false;
        if ($(othis).parent().parent().hasClass('pagination')) return false;
        $('.linkToolEditable').show();
        $('.linkToolEditable')
            .find('.linkToEdit')
            .hide()
            .end()
            .find('.linkToRemove')
            .hide()
            .end()
            .find('.buttonToClipboard')
            .hide()
            .end()
            .find('.buttonToEdit')
            .hide()
            .end();
        var h = $(othis).attr('href') || '';

        if (h.search(parent.wex.url.WYS_SHOW_URL) == -1) {
            h = h.replace(parent.wex.url.baseUrl, parent.wex.url.WYS_SHOW_URL);
        }

        var oLinkk = $(
            '<a href="' +
                h +
                '"> <i class="uk-icon-external-link"></i>  ' +
                h +
                '</a>'
        );
        if (!h.match(/^\#/)) {
            oLinkk.attr('target', '_blank');
        }
        $('.linkTo').html(oLinkk);
        $('.linkToolEditable').css({
            left: $(othis).offset().left,
            top: $(othis).offset().top,
        });
        return false;
    };

    RVwys.replaceWebVariable = function (html) {
        //
        var patVar = {
            webThemeUrl: parent.wex.url.WEB_THEME_URL,
            cdnURL: parent.wex.cdn.cdnURL,
            USER_EMAIL: parent.wex.users.USER_EMAIL,
        };
        var pat = '{(' + Object.keys(patVar).join('|') + ')}';
        pat = new RegExp(pat, 'img');
        return html.replace(pat, function (m, i) {
            //alert(i)
            return patVar[i];
        });
    };

    RVwys.loadToolbar = function () {
        console.log('------>loadToolbar');
        var oThis = this;
        if ($('body').html() == undefined) {
            return setTimeout(function () {
                RVwys.loadToolbar();
            }, 50);
        }
        /*
            var setToolbar = themeToolbar.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');
            var setFooter = themeFooter.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');
            var setRightbar = themeRightbar.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');
            var setDynamicbar = themeDynamicbar.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');


            setToolbar = RVwys.replaceWebVariable(setToolbar);
            setFooter = RVwys.replaceWebVariable(setFooter);
            setRightbar = RVwys.replaceWebVariable(setRightbar);
            setDynamicbar = RVwys.replaceWebVariable(setDynamicbar);
            //setRightbar = RVwys.replaceWebVariable(setRightbar);
            var objToolbar ='<div id="wys-toolbar" class="wys-toolbar RVwys" style="width:auto; display:;">'+setToolbar+'</div>';
            setFooter ='<div id="wys-footer" class="wys-footer RVwys" style="display:none;width:100%;height:20px;">'+ setFooter +'</div>';
            setRightbar ='<div id="wys-rightbar" class="wys-rightbar " >'+ setRightbar +'</div>';
            setDynamicbar ='<div id="wys-dynamic" class="wys-dynamic RVwys" >'+ setDynamicbar +'</div>';
            */
        if (!parent.$('.RVwys').get(0)) {
            var parentBody = parent
                .$('body')
                //  .prepend($(objToolbar))
                // .prepend($(setDynamicbar))

                .end()
                .each(function () {
                    //parentBody = parent.$('body').find('.toolwysiwyg').append(objToolbar).end.append(setFooter).end().each(function(){
                    RVwys.disabledPlugin($(this));
                    //$(this).find('#dynamictoolbar_StandardWordButton').after($(this).find('#dynamictoolbar_Instable'));

                    if (!$('#wys-rightbar').get(0)) {
                        console.log('add rightbar');
                        console.log('body obejct frame ->' + $('body').get(0));
                        //alert('eeee');

                        $.when($('body').append(setRightbar)).then(function () {
                            alert('in wys' + $('body').html());
                            RVwys.regisEventOnRightBar();
                        });
                    }
                    parent.$('.wys-toolbar').show();
                });
        } else {
            parentBody = parent.$('body');
        }
        parent.RVwys.runTriggerEvent();

        if (themeName == 'uikit') {
            RVwys.runTriggerWidgetEvent();
        }
        oThis.interfaceDesignMode(true);

        var frameBody = $('#frameBody').get(0);
        parent.frameBody = parent.$('#frameBody').get(0);
        return this;
    };
    RVwys.runTriggerEvent = function () {
        try {
            $('#frameBody').contents().find('.widgetError').remove();
            $(document).trigger('editorReady');
        } catch (e) {
            console.error(e);
            console.log('editorReady error-' + e);
        }
    };

    RVwys.runTriggerWidgetEvent = function () {
        $(document).trigger('designReady');
    };

    RVwys.eventDynamictoolsbarMouseDown = function (event) {
        if (event) {
            $(document).trigger('mousedown_' + event.replace('.', ''));
        }
    };
    RVwys.eventDynamictoolsbarMouseUp = function (event) {
        if (event) {
            $(document).trigger('mouseup_' + event.replace('.', ''));
        }
    };
    RVwys.reloadObjEditorSource = function () {
        this.editorFrameSource = document.getElementById('editorSource');
        if (!this.editorFrameSource) return false;
        this.editorFrameDoc =
            this.editorFrameSource.contentWindow ||
            this.editorFrameSource.contentDocument;
        if (this.editorFrameDoc.document) {
            return (this.editorSource = this.editorFrameDoc.document);
        }
        return false;
    };
    RVwys.displaySource = function (oEditor) {
        if (parent.$('#editorSource').is(':hidden')) {
            this.inSource = false;
            return false;
        }
        if (RVwys.inSource) {
            return false;
        }
        this.inSource = true;
        parent.RVwys.inSource = true;
        this.editorFrameSource = document.getElementById('editorSource');
        console.log('this.editorFrameSource-->' + this.editorFrameSource);
        if (!this.editorFrameSource) return false;
        this.editorFrameDoc =
            this.editorFrameSource.contentWindow ||
            this.editorFrameSource.contentDocument;
        if (this.editorFrameDoc.document) {
            this.editorSource = this.editorFrameDoc.document;
        }

        var disSource = this.editorSource;
        this.editorSource.body.style.wordWrap = 'break-word';
        disSource.contentEditable = 'true';
        disSource.designMode = 'On';
        var textDatas = $(oEditor).html();
        textDatas = textDatas
            .replace(/ /, '&nbsp;&nbsp;')
            .replace(/"/gi, '&quot;')
            .replace(/>/gi, '&gt;')
            .replace(/</gi, '&lt;');
        textDatas = textDatas.replace(/[\n|\r]/g, '<br/>').replace(/\r/gi, '');
        disSource.open();
        var aTempBody = {};
        aTempBody['HEADER'] = '';
        aTempBody['CONTENT'] = textDatas;
        aTempBody['PATHSOURCE'] =
            RVwys.baseUrl + '/theme/default/css/source.css';
        console.log('displaySource->data' + aTempBody['CONTENT']);
        disSource.write(
            htmlHeadSource.replace(
                /#(HEADER|CONTENT|PATHSOURCE)#/gim,
                function (m, i) {
                    return i ? aTempBody[i] : '';
                }
            )
        );
        disSource.close();
        var objcur = this;
        setTimeout(function () {
            $(disSource).mouseover(function () {
                parent.pointerMode = 'source';
            });
            $(disSource.body).mousedown(function () {
                parent
                    .$(
                        '.sprite_wysiwyg,.sprite_wysiwyg_big,.layoutMode,.navigator,.rvselectbox'
                    )
                    .each(function () {
                        if ($(this).attr('id') != undefined) {
                            if (!$(this).attr('id').match(/_ena/gi)) {
                                $(this).attr(
                                    'id',
                                    $(this).attr('id').replace('_dis', '') +
                                        '_ena'
                                );
                            }
                        }
                        if ($(this).get(0).tagName.toLowerCase() == 'button') {
                            $(this).attr('disabled', 'disbled');
                        }
                    });
            });
            objcur.runEvents_SourceView($(disSource.body));
            objcur.updateSource();
        }, 50);
    };

    wys.event = function (Event, func) {
        const eventMuti = Event.split(',');
        console.log('wys.event');
        console.log(eventMuti);
        const eov = Event.split(':');
        $.each(eventMuti, function () {
            if (Array.isArray(eov)) {
                RVwys.oEventsDesignViewByWidget[Event] = {};
                RVwys.oEventsDesignViewByWidget[Event][eov[0]] = eov[1];
                RVwys.oEventsDesignViewByWidget[Event]['func'] = func;
            }
        });
    };
    /*
    wys.addEvent = function(Event, func) {
        let eov = Event.split(":");
        if (Array.isArray(eov)) {
            RVwys.oEventsDesignViewByWidget[Event] = {};
            RVwys.oEventsDesignViewByWidget[Event][eov[0]] = eov[1];
            RVwys.oEventsDesignViewByWidget[Event]["func"] = func;
        }
    };
    */
    RVwys.designViewAddEvent = function (Event, func) {
        var c = RVwys.oEventsDesignView.length;
        RVwys.oEventsDesignView[c] = { event: Event, func: func };
    };

    RVwys.sourceViewAddEvent = function (Event, func) {
        var c = RVwys.oEventsSourceView.length;
        RVwys.oEventsSourceView[c] = { event: Event, func: func };
    };
    RVwys.activeSubtoolbar = function (pluginName) {
        var oThis = this;

        $('.subtoolbar')
            .hide()
            .each(function () {
                $('#subtoolbar_' + pluginName)
                    .show()
                    .each(function () {
                        oThis.effSubToobarShow();
                    });
            });
    };
    RVwys.effSubToobarShow = function () {
        $('.subtools').slideDown('fast', function () {
            // Animation complete.
            $(this).show();
            RVwys.setPositionTheme();
        });
    };

    RVwys.getParentTable = function (othis, tagName) {
        console.log(othis);
        console.log(tagName);

        if (othis.get(0) && othis.hasClass('editable_area')) {
            return false;
        }

        if (othis.get(0) && othis.get(0).tagName.toLowerCase() != tagName) {
            return this.getParentTable(othis.parent(), tagName);
        }

        return othis;
    };

    RVwys.getParentByClass = function (othis, className) {
        return othis.closest('.' + className);
        /*
        if(!othis.hasClass(className)) {
        return RVwys.getParentByClass(othis.parent(), className);
        }
        return othis;
         */
    };

    RVwys.getParentByTags = function (othis, tag) {
        console.log('(typeof(tag)).toLowerCase()' + (typeof tag).toLowerCase());
        if ((typeof tag).toLowerCase() == 'object') {
            var tagset = tag;
        } else {
            var tagset = { tag: true };
        }
        console.log('(typeof(tag)).toLowerCase()' + tagset);
        var thisTag = othis.get(0).tagName.toLowerCase();
        console.log('getParentByTags->' + othis.get(0).tagName);
        if (othis.hasClass('RVWYSIWYGAREA')) {
            console.log('getParentByTags-> return exit');
            return false;
        }
        if (!tagset[thisTag]) {
            console.log('getParentByTags-> return next');
            return RVwys.getParentByTags(othis.parent(), tagset);
        }
        return othis;
    };

    RVwys.setPositionTheme = function () {
        var toolbarHeight = parent.$('#toolbar').height();
        var footerHeight = parent.$('#Footer').height();
        var bar = parent.$('#topbar').height();
        var frameBB = parent.$('#frameBody').is(':visible')
            ? parent.$('#frameBody')
            : parent.$('#fEffect');
        //frameBB.height(parent.window.innerHeight - (toolbarHeight+footerHeight));
        frameBB.height(parent.window.innerHeight - bar);
        console.log(parent.window.innerHeight + '-' + bar);
    };
    // button state
    RVwys.addButtonStarteByTags = function (btnName, tgNames) {
        RVwys.oButtonStateByTags[tgNames] = btnName;
    };

    RVwys.switchButtonStarteGroup = function (obj, cssClass) {
        parent
            .$('.' + cssClass)
            .each(function () {
                var cID = $(this).attr('id');
                var tragetID =
                    obj.get(0).id == $(this).get(0).id ? cID + '_dis' : cID;
                var str_id = cID.match(/_dis/gi)
                    ? cID.replace('_dis', '')
                    : tragetID;
                $(this).attr('id', str_id);
            })
            .end();
    };
    RVwys.activeButtonStarte = function (id, objButton) {
        //console.log('activeButtonStarte'+id)
        if (!id) {
            return false;
        }
        var str_id = id.match(/_dis/gi) ? id.replace('_dis', '') : id + '_dis';
        if (objButton) {
            objButton.find('#' + id).attr('id', str_id);
            objButton.find('#mini_' + id).attr('id', 'mini_' + str_id);
        } else {
            parent.$('#' + id).attr('id', str_id);
            parent.$('#mini_' + id).attr('id', 'mini_' + str_id);
        }
    };
    RVwys.switchButtonStarte = function (obj) {
        var id = obj.get(0).id;
        var str_id = id.match(/_dis/gi) ? id.replace('_dis', '') : id + '_dis';
        parent.$(obj).attr('id', str_id);
    };

    RVwys.setActiveButtonStarte = function (obj, objButton) {
        var tgName = obj.get(0).tagName.toLowerCase();
        if (tgName) {
            var id = RVwys.oButtonStateByTags[tgName];

            RVwys.activeButtonStarte(id, objButton);
        }
        var oNextParent = obj.parent();
        if (oNextParent.get(0).tagName != undefined) {
            if (
                oNextParent.get(0).tagName.toLowerCase() != 'body' &&
                oNextParent.get(0).tagName.toLowerCase() != 'html' &&
                oNextParent.get(0).tagName.toLowerCase() != 'font' &&
                oNextParent.hasClass('RVWYSIWYGAREA') != true
            ) {
                this.setActiveButtonStarte(oNextParent, objButton);
            }
        }
    };
    RVwys.setNormalButtonStarteByOne = function (obj) {
        if (obj.attr('id') != undefined) {
            obj.attr('id', obj.attr('id').replace('_dis', ''));
            obj.attr('id', obj.attr('id').replace('_ena', ''));
        }
        if (obj.get(0).tagName.toLowerCase() == 'button') {
            obj.removeAttr('disabled');
        }
    };
    RVwys.setNormalButtonStarte = function () {
        var objClassStarte =
            '.sprite_wysiwyg,.sprite_wysiwyg_big,.navigator,.rvselectbox,.layoutMode';
        if (!$('.rs_mainpage').is(':visible')) {
            objClassStarte =
                '.sprite_wysiwyg,.sprite_wysiwyg_big,.navigator,.rvselectbox';
            //            isDisTem = parent.$('.wys-mastertemplate').get(0).id;
        }
        parent.$(objClassStarte).each(function () {
            RVwys.setNormalButtonStarteByOne($(this));
        });
        if (!$('.rs_mainpage').is(':visible')) {
            parent
                .$('.wys-mastertemplate')
                .attr('id', 'wys-mastertemplate_dis');
        }
        $('.editorCurrentActive')
            .removeClass('editorCurrentActive')
            .end()
            .each(function () {
                $(this).addClass('editorCurrentActive');
            });
    };
    RVwys.activeEventButtonStarte = function () {
        RVwys.setNormalButtonStarte();
        var range = this.getRange();
        if (range) {
            if (range.startContainer) {
                tagActive = $(range.startContainer).parent();
            } else {
                range.select();
                //var startRange = this.cloneRange();
                range.collapse(true);
                try {
                    tagActive = $(range.parentElement());
                } catch (e) {
                    tagActive = $(range.commonParentElement());
                }
            }
            RVwys.setActiveButtonStarte(tagActive);
        }
    };
    RVwys.activeEventButtonStarteMini = function (obj) {
        RVwys.setNormalButtonStarte();
        var range = this.getRange();
        if (range) {
            try {
                var parentElement = range.parentElement();
            } catch (e) {
                var parentElement = range.commonParentElement();
            }
            tagActive = range.startContainer
                ? $(range.startContainer).parent()
                : $(parentElement);
            RVwys.setActiveButtonStarte(tagActive, obj);
        }
    };
    RVwys.nextLoad = function (msg) {
        $('#msg-previewload')
            .find('.fadeInDown')
            .removeClass('fadeInDown')
            .addClass('fadeOutDown')
            .each(function () {})
            .end()
            .prepend('<div class="animated fadeInDown">' + msg + '</div>');
    };
    RVwys.nextMainLoadMsg = function (msg) {
        $('#msg-mainload')
            .find('.fadeInDown')
            .removeClass('fadeInDown')
            .addClass('fadeOutDown')
            .each(function () {})
            .end()
            .prepend('<div class="animated fadeInDown">' + msg + '</div>')
            .show();
    };

    RVwys.nextMainLoad = function (msg, delay = 50) {
        alert('nextMainLoad');
        setTimeout(function () {
            RVwys.nextMainLoadMsg(msg);
        }, delay);
    };
    RVwys.rgb2hex = function (rgb = string) {
        if (rgb == 'rgba(0, 0, 0, 0)') {
            return '';
        }
        rgb = rgb.match(
            /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
        );
        return rgb && rgb.length === 4
            ? '#' +
                  ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                  ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                  ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2)
            : '';
    };

    RVwys.showDynamic = function () {
        $('.title-panel').effect(
            'transfer',
            { to: $('.wys-dynamic'), className: 'ui-effects-transfer' },
            '50',
            function () {
                dynamicShow = true;
                $('.wys-dynamic').show();
                $('#showHideDynamic, .wys-rowTwo').hide();
            }
        );
    };

    RVwys.hideDynamic = function () {
        $('.wys-rowTwo ').show();
        $('.wys-dynamic').effect(
            'transfer',
            { to: $('.title-panel'), className: 'ui-effects-transfer' },
            '1000',
            function () {
                dynamicShow = false;
                $('.wys-dynamic').hide();
                $('#showHideDynamic').show();
            }
        );
    };

    RVwys.showHidePanelAll = function () {
        //alert($('#showHidePanel').text())
        if ($('#showHidePanel').text() == 'hide') {
            RVwys.hidePanel();
        } else {
            RVwys.showPanelAll();
        }
    };

    RVwys.hidemgActive = function () {
        $('.layoutResize').remove();
        $('.navMenuAll').hide();
        //        ปิดซ่อน mgactive รูปภาพ
        //        $('.mgActive').removeClass('mgActive');
    };

    RVwys.showPanelActive = function () {
        parent.$('.wys-dynamic').toggle(parent.dynamicShow);
        parent.$('.wys-rowTwo').toggle(!parent.dynamicShow);
    };

    RVwys.showPanelAll = function () {
        $('.wys-rowTwo,.wys-dynamic,.mode-element').show();
        $('.widget-blocks,.imageLib').hide();
        isSectionBG = false;
    };

    RVwys.hidePanelAll = function () {
        //alert('hidePanel')
        console.log('showHidePanel hide--->' + $('#showHidePanel').get(0));
        //    	$('.wys-rowTwo,.wys-rowThree,.wys-pEffect,.wys-rowFour,.wys-rowHeader,.wys-menuDesign,.wys-navPropertie,.wys-rowTen,.wys-rowFormSeting,.wys-topmenuDesign').hide();
        $('.wys-panel, .widget-blocks, .wys-dynamic').hide();

        try {
            $('#frameBody').get(0).contentWindow.RVwys.hidemgActive();
        } catch (e) {
            RVwys.hidemgActive();
        }

        //$('.wys-rowTwo').height(22);
    };

    RVwys.showHidePanel = function () {
        $('.main-panel').toggle();
        if ($('#showHidePanel').hasClass('uk-icon-caret-down')) {
            $('#showHidePanel')
                .removeClass('uk-icon-caret-down')
                .addClass('uk-icon-caret-up');
        } else {
            $('#showHidePanel')
                .removeClass('uk-icon-caret-up')
                .addClass('uk-icon-caret-down');
        }
    };

    RVwys.showPanelWidgetBlock = function (obj) {
        var aProperName = {};
        aProperName['jotform'] = rvLang('Form Editor');
        aProperName['album'] = rvLang('Album Editor');
        aProperName['Facebook_Like'] = rvLang('Facebook Like Editor');
        aProperName['Facebook_Comment'] = rvLang('Facebook Comment Editor');
        aProperName['Facebook_page'] = rvLang('Facebook page Editor');
        aProperName['googleMap'] = rvLang('Google Maps Editor');
        aProperName['googleMap'] = rvLang('Google Maps Editor');
        aProperName['blog_cat'] = 'Blog info Setting';
        aProperName['blog_Breadcrumb'] = 'Breadcrumb Setting';
        aProperName['blog_NextLast'] = 'Navigator Setting';
        aProperName['blog_RecentPost'] = 'Recent Post Setting';
        aProperName['blog_PostInCat'] = 'Post Setting';

        var s =
            $(obj).attr('formtype') == ''
                ? rvLang('Setting')
                : $(obj).attr('formtype');

        //parent.$('.setting-widget').text(s);
        if ($(obj).attr('formtype').match(/^blog/)) {
            parent
                .$('.setting-widget')
                .attr(
                    'onclick',
                    'RVwys.widget.blog.EventSetting("' +
                        s +
                        '","' +
                        aProperName[s] +
                        '");'
                );
        }
        parent.$('.setting-widget').text(aProperName[s]);

        //alert('.panelWidget.'+s)
        $('.panelWidget')
            .hide()
            .each(function () {
                $('.panelWidget.' + s).show();
            });

        $('.wys-rowTwo,.widget-blocks').show();
        $(
            '.dtbartext,.dtbarimage,.dtbartable,.dtbarCommon,.wys-dynamic,.imageLib,.mode-element'
        ).hide();
        console.log('showHidePanel--->' + $('#showHidePanel').get(0));
        //$('#showHidePanel').text('hide');
        RVwys.setCurrentRowBG(parent.RVwys.targetAnimatObj);
        //    	var cmdMaster = $(obj).attr('onclick');
        //    	var cmd = cmdMaster.replace(/showleftMenu\(this\)/img,'showProp()');
        //    	$('.setting-widget').attr('onclick',cmd);
        //$('.wys-rowTwo').height(600);
        //parent.$('.accordion-panel').accordion( "option", "active", 0 );
        parent.$('.mode-element').tabs('option', 'active', 0);
    };

    //end button state
    RVwys.widget = {};
    RVwys.uikit = {};
    RVwys.uikit.blockprop = {};
    RVwys.uikit.blockprop.effect = {};
    RVwys.uikit.Tools = function (visibleName) {
        var frBody = $('#frameBody').contents();
        var oVildKey = { show: true, hide: false, undefined: false };

        frBody.find('#wys-rightbar').toggle(oVildKey[visibleName]);
        if (oVildKey[visibleName]) {
            frBody.find('.mg').find('.navMenuAll').remove();
        }

        frBody.find('.bodyTemplates').each(function () {
            $(this).removeClass('bodyTemplates');
            $(this).addClass('bodyTemplate');
        });
    };
    RVwys.uikit.layoutBorder = function () {
        $('.layoutCurrent')
            .removeClass('layoutCurrent')
            .end()
            .find('.design-block')
            .find('.layoutfix .editable_area')
            .addClass('layoutCurrent');
    };

    RVwys.uikit.loadSectionDesign = function (isEditPage) {
        //event
        $('#design-sortable').html('<div class="txtSidebar">Loading...</div>');
        var layout = $('.design-block').attr('rv-layout');
        if (layout == 'undefined' || layout == undefined) {
            setTimeout(function () {
                RVwys.uikit.loadSectionDesign();
            }, 500);
        }

        var request = $.ajax({
            method: 'GET',
            url: parent.wex.cdn.cdnBlockDesign,
            dataType: 'html',
        });

        /*replace  rvs_library*/
        request.done(function (data) {
            if (data != '') {
                var pats2 = new RegExp('../rvsitebuilder/rvs_library/', 'img');
                var data = data.replace(pats2, function (m, i) {
                    return parent.wex.cdn.LIBRARY_URL + '/';
                });
                var pats = new RegExp(
                    '../rvsitebuilder/UikitTemplate/uikit_block_design/(25|33|50|66|75|100)/images/',
                    'img'
                );
                data = data.replace(pats, function (m, i) {
                    return (
                        parent.wex.url.SGL_JS_WEBROOT +
                        '/UikitTemplate/uikit_block_design/' +
                        i +
                        '/images/'
                    );
                });
            }
            $('#design-sortable').html('');
            var oRolsBlock = $('<div/>').html(data);
            oRolsBlock.find('icon').each(function () {
                $('#design-sortable').append(
                    $(this)
                        .find('.hvr-glow')
                        .attr('data', $(this).next('design').html())
                );
            });
        });
        request.fail(function (jqXHR, textStatus) {
            //RVwys.uikit.loadSectionDesign();
            console.log('Cannot load ' + parent.wex.cdn.cdnBlockDesign);
            console.log('Error msg ' + jqXHR.responseJSON.message);
        });
    };

    RVwys.uikit.blockDisplay = function (oThis) {
        $('.navMenuBlock')
            .hide()
            .each(function () {
                $(oThis).parent().next().show();
            });
        var mg = RVwys.getParentByClass($(oThis), 'mg');
        var bgColor = mg.find('.rvsb_design_block').css('background-color');
        mg.find('.bsnCurrentBG').css({ 'background-color': bgColor });
    };

    RVwys.uikit.widgetList = function () {
        $('dd ul').hide();
        $('.widgetAUX dd ul').show();
    };

    RVwys.uikit.widgetSelLink = function (oThis) {
        $('.widgetAUX dt a span').text(oThis.text());
        $(".widgetPanal[id='mywidget'], dd ul").hide();
        if (oThis.attr('set') == 'all') {
            $(".widgetPanal[id!='mywidget']").show();
        } else {
            $('.widgetPanal')
                .hide()
                .end()
                .each(function () {
                    $('.' + oThis.attr('set')).show();
                });
        }
    };

    RVwys.uikit.blockprop.eventEditFocus = function (oThis) {
        $('.navMenuAll').hide();
        $('.mgActive').removeClass('mgActive');
        //        try{
        //        	var ukBlock = RVwys.getParentByClass(oThis,'rvsb_design_block');
        //        	ukBlock.addClass('mgActive');
        //        }catch(e) {
        //        	return false;
        //        }
        var ukBlock = oThis.closest('.rvsb_design_block');
        ukBlock.addClass('mgActive');

        var thisPos = oThis.position();

        if (!ukBlock.find('.navMenu-blockMainSetting').get(0)) {
            ukBlock.prepend($('#blockMainSetting').html());
        }
        if (ukBlock.find('.uk-form').get(0)) {
            RVwys.uikit.formAPIUpdate(ukBlock.find('.uk-form'));
            ukBlock.find('.handledClone').remove();
        }

        RVwys.removePreviewWidget();

        console.log('eventEditFocus');
        console.log('eventEditFocus' + oThis.get(0).className);
        console.log('thkFormEditor ' + oThis.hasClass('thkFormEditor'));

        ukBlock.find('.navMenu-blockMainSetting').toggle(parent.nviActive);
        if (thisPos.left < 0) {
            thisPos.left = 0;
        }
        // block ative menu

        if (!oThis.get(0).id || oThis.get(0).id == '') {
            var isNow = String($.now());
            var idpref = $.md5(isNow);
            var id = 'editable_area_custom' + idpref;
            oThis.attr('id', id);
        }
    };
    RVwys.showMenuRightBar = function () {
        var f;
        //active/design
        var menuBar = String(window.location).match(/active\/design/gim)
            ? '.bar-left-design'
            : '.bar-left-content';
        try {
            f = parent.$('#frameBody').get(0).contentWindow;

            if (!f.$(menuBar).get(0)) {
                setTimeout(function () {
                    RVwys.showMenuRightBar();
                }, 50);
            } else {
                f.$(menuBar).show();
                RVwys.regisEventOnRightBar();
            }
        } catch (e) {
            setTimeout(function () {
                RVwys.showMenuRightBar();
            }, 50);
        }
    };

    RVwys.eventClickblock = function (oThis, e = null) {
        console.log('function =====> RVwys.eventClickblock');

        if (e) {
            parent.RVwys.getrowProperties = RVwys.getParentByClass(
                $(e.target),
                'rvsb_design_block'
            );
            parent.RVwys.getRowBG = RVwys.getParentByClass(
                $(e.target),
                'rvsb_design_block'
            );

            if (
                parent.RVwys.getrowProperties.closest('#selected_footer').get(0)
            ) {
                parent.RVwys.getrowProperties = parent.RVwys.getrowProperties.find(
                    '#footerTemplate'
                );
                window.isFooterBG = true;
            } else {
                parent.RVwys.getrowProperties = parent.RVwys.getrowProperties.parent();
            }

            if (parent.RVwys.getRowBG.get(0)) {
                RVwys.setCurrentRowBG(e.target);
                RVwys.setCurrentBGIMAGE(e.target);
                RVwys.setCurrentParallaxCustomSection(e.target);
            }

            if (parent.RVwys.getrowProperties.get(0)) {
                RVwys.setCurrentShadowSection(parent.RVwys.getrowProperties);
                RVwys.setCurrentOverlapSection(parent.RVwys.getrowProperties);
                RVwys.setCurrentBoxSection(parent.RVwys.getrowProperties);
            }
        }

        $('.navMenuAll').hide();
        $('.mgActive').removeClass('mgActive');
        $('.formsProp').hide();

        var ukBlock = oThis.find('.rvsb_design_block');
        var isform = ukBlock.find('.uk-form').get(0);
        var isWidget = ukBlock.closest('.mgwidget').get(0);
        var isTopMenu = ukBlock.closest('.topmenudesign').get(0);
        var isFooter = ukBlock.closest('#selected_footer').get(0);

        if (isTopMenu || isFooter) {
            var bms = $('#blockMainSetting');

            if (!ukBlock.find('.navMenu-blockMainSetting').get(0)) {
                ukBlock.prepend(bms.html());
            }
        }

        if (isform) {
            ukBlock.find('.formsProp').show();
            ukBlock.find('.handledClone').remove();
        }

        if (isWidget) {
            //	ukBlock.find('.handledClone').remove();
            //	ukBlock.find('.handledrowParallax').remove();
        }

        ukBlock.find('.navMenuAll').toggle(parent.nviActive);
        ukBlock.addClass('mgActive');
    };

    RVwys.uikit.blockprop.setBlockAign = function (oThis) {
        var editW = $(oThis).parent().find('.rvsb_design_block');
        $.each(
            ['uk-text-left', 'uk-text-right', 'uk-text-center'],
            function (k, v) {
                if (editW.hasClass(v)) {
                    editW.removeClass(v);
                }
            }
        );
        editW.addClass($(oThis).val());
    };
    RVwys.uikit.blockprop.setEffectType = function (oThis) {
        frameBody = parent.$('#frameBody').get(0);
        frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
        if (frameBodyDoc.document) frameBodyDoc = frameBodyDoc.document;
        html = frameBody.contentWindow.$('html').html();
        frameBodyDoc.open();
        frameBodyDoc.write(html);
        frameBodyDoc.close();
    };

    RVwys.uikit.blockprop.linkActive = function (objEf, oClassName) {
        $('dd ul').hide();
        $(objEf)
            .parent()
            .parent()
            .parent()
            .parent()
            .find('dt a span')
            .eq(0)
            .text($(objEf).find('span').text())
            .attr('set', $(objEf).attr('set'));

        RVwys.uikit.blockprop.setEffect(objEf);
    };

    RVwys.uikit.blockprop.effectActive = function (objEf) {
        $('dd ul').hide();
        $('.animationEffect dt a span').text($(objEf).text());
        $('.animationEffect dt a span').attr('set', $(objEf).attr('set'));
        RVwys.uikit.blockprop.setEffect(objEf);
    };

    RVwys.uikit.blockprop.showUIKitEffect = function (othis, objEf) {
        $('dd ul').hide();
        $(objEf).show();
    };

    RVwys.uikit.blockprop.previewEffectEnd = function (othis) {
        RVwys.nextLoad(rvLang('success'));
        setTimeout(function () {
            if ($('#wys-previewmode').attr('act') == undefined) {
                $('.rvwysEffectCenter').hide();
                $('.rvwys-load').hide();
                $(othis).show();
                RVwys.uikit.blockprop.previewFacebook(othis);

                setTimeout(function () {
                    var fEffect = $('#fEffect').get(0).contentWindow;
                    fEffect.FB.XFBML.parse();

                    fEffect.scrollSpeed(150, 1600);
                }, 1000);
            }
        }, 1000);
    };

    RVwys.uikit.blockprop.previewFacebook = function (othis) {
        othis.each(function () {
            //replace facebook like
            $(this)
                .contents()
                .find('.imgFacebookLike')
                .each(function () {
                    var getPreview = jQuery(this).attr('cmdPreviewWys');
                    if (getPreview) {
                        getPreview = atob(getPreview);
                        jQuery(this).after(getPreview);
                    }
                    jQuery(this).remove();
                });

            //replace facebook comment
            $(this)
                .contents()
                .find('.imgFacebookComment')
                .each(function () {
                    var getPreview = jQuery(this).attr('cmdPreviewWys');
                    if (getPreview) {
                        getPreview = atob(getPreview);
                        jQuery(this).after(getPreview);
                    }
                    jQuery(this).next().css('display', 'block');
                    jQuery(this).remove();
                });

            //replace facebook fanpage
            $(this)
                .contents()
                .find('.imgFacebookPage')
                .each(function () {
                    var getPreview = jQuery(this).attr('cmdPreviewWys');
                    var getAtob;
                    if (getPreview) {
                        getAtob = atob(getPreview);
                        if (getAtob) jQuery(this).after(getAtob);
                    }
                    $(this).remove();
                });

            $(this)
                .contents()
                .find('.video_youtube')
                .each(function () {
                    var getPreview = jQuery(this).attr('cmdPreviewWys');
                    var getAtob;
                    if (getPreview) {
                        getAtob = atob(getPreview);
                        if (getAtob) $(this).after(getAtob);
                    }
                    $(this).remove();
                });

            $(this)
                .contents()
                .find('iframe.fb_ltr')
                .each(function () {
                    $(this).css('height', '100%');
                });
        });
    };

    RVwys.uikit.blockprop.preveiwLoad = function () {
        var fE = $('#fEffect').get(0);
        var previewHTML = previewhtml.replace(
            /#(HEADER|CONTENT)#/gim,
            function (m, i) {
                str = '';
                switch (i) {
                    case 'HEADER':
                        str =
                            dHead +
                            '<style>.editable_area:empty:not(:focus ):before  {visibility:hidden;}</style>';
                        break;
                    case 'CONTENT':
                        str = dBody + '<end style="display:none;">end</end>';

                        break;
                    default:
                        break;
                }
                return str;
            }
        );

        frameBodyDoc = fE.contentWindow || fE.contentDocument;
        if (frameBodyDoc.document) frameBodyDoc = frameBodyDoc.document;
        frameBodyDoc.open();
        frameBodyDoc.write(previewHTML);
        frameBodyDoc.close();
        setTimeout(function () {
            RVwys.uikit.blockprop.findBody();
        }, 1000);
    };
    var dHead = '';
    var dBody = '';
    RVwys.uikit.blockprop.findBody = function () {
        if ($('#fEffect').contents().find('end').prop('tagName') == 'END') {
            RVwys.uikit.blockprop.previewEffectEnd($('#fEffect'));
        } else {
            setTimeout(function () {
                RVwys.uikit.blockprop.findBody();
            }, 500);
        }
    };

    RVwys.uikit.blockprop.previewEffect = function (oThis) {
        var frBody = parent.$('#frameBody');
        //$('.fb_reset').remove();
        frBody.contents().find('.fb_reset').remove();
        frBody.contents().find('.blockTools').remove();
        frBody
            .contents()
            .find('div[rv-data-uk-scrollspy]')
            .removeClass(RVwys.effectClass)
            .end()
            .each(function () {
                $('.rvwysEffectCenter').show();
                $('.rvwys-load').hide();
                RVwys.nextLoad(
                    '<div class="animated fadeInDown">' +
                        rvLang('load html please wait') +
                        '<img class="loading" src="' +
                        parent.wex.url.rvsThemImage +
                        'loading.gif"width="29" height="27" border="0" align="absmiddle" /></div>'
                );
                var html = frBody.contents().find('html').html();
                //    		dHead = frBody.contents().find('head').html();
                //    		dBody = frBody.contents().find('body').html();
                dHead = frBody.contents().find('head').clone().html();
                dBody = frBody
                    .contents()
                    .find('body')
                    .clone()
                    .find('.wys-rightbar')
                    .remove()
                    .end()
                    .html();
                frBody.hide();

                dHead = dHead
                    .replace(
                        /(<script[^>]*?rvwysiwyg\-uikit.*?>.*<\/script\s*>)/gim,
                        ''
                    )
                    .replace(
                        /<link [^>]* href="((?:.*)editableCSS.php(?:.*))">/gim,
                        function (m, i) {
                            //alert(i)
                            return (
                                '<link href="' +
                                i.replace(
                                    'editableCSS.php',
                                    'rvsb-common.css'
                                ) +
                                '">'
                            );
                        }
                    )
                    .replace(
                        /<script[^>]*?maps.googleapis.com.*?>.*<\/script\s*>/gim,
                        ''
                    );
                var matchSrcPublishScript = dBody.match(
                    /<script [^>]* src="(.*)footerMgr.js"><\/script>/
                );
                dBody = dBody
                    .replace(/\<\!--\?/gim, '#RVWYSIWYGSTARTPHP#')
                    .replace(/\?--\>/gim, '#RVWYSIWYGENDPHP#')
                    .replace(/rv-data-uk-scrollspy/gim, 'data-uk-scrollspy')
                    .replace(
                        matchSrcPublishScript[0],
                        matchSrcPublishScript[0] +
                            '<script src="' +
                            matchSrcPublishScript[1] +
                            '/googleMgr.js"></script>'
                    );
                var fEffect =
                    '<iframe onload="RVwys.uikit.blockprop.preveiwLoad()" id="fEffect"name="fEffect" frameBorder="0" width="100%" style="display:none;height:' +
                    (frBody.height() - 0) +
                    'px" height="' +
                    (frBody.height() - 0) +
                    'px" class="fEffect animated fadeIn" src=""></iframe>';
                $('#fBody').append(fEffect);
            });
    };

    RVwys.uikit.blockprop.remove = function (oThis) {
        var mg = RVwys.getParentByClass($(oThis), 'mg');
        var oForm = mg.find('.uk-form');
        RVwys.removePreviewWidget();
        if (oForm.get(0)) {
            RVwys.uikit.formAPIRemove(oForm);
        }
        mg.remove();
    };

    RVwys.uikit.blockprop.clone = function (oThis) {
        var mg = RVwys.getParentByClass($(oThis), 'mg');
        var mgClone = mg.clone();
        //mg.removeClass('mg')
        RVwys.removePreviewWidget();
        mgClone
            .find('.mgActive')
            .removeClass('mgActive')
            .end()
            .find('.navMenu-blockMainSetting')
            .hide();

        mgClone.find('.blockTools').remove();
        mg.after(mgClone);
        mgClone
            .find('.RVWYSIWYGAREA')
            .each(function () {
                var id = $(this).attr('id') + $(this).index();
                $(this).attr('id', id);
                var testEditor = RVwys.EditorByClass('#' + id, true);
            })
            .eq(0)
            .focus();
    };
    RVwys.eventMG = function (oThis) {
        $('.navMenuAll').hide();
        $('.mgActive').removeClass('mgActive');
        var ukBlock = oThis.find('.rvsb_design_block');
        ukBlock.find('.navMenu-blockMainSetting').toggle(parent.nviActive);
        ukBlock.addClass('mgActive');
    };
    RVwys.uikit.blockprop.rowParallax = function () {
        RVwys.removePreviewWidget();

        var rowFour = parent.$('.wys-rowFour');
        var rowTwo = parent.$('.wys-rowTwo');
        if (rowTwo.is(':visible')) {
            var posRowTwo = parent.$('.wys-rowTwo').position();
            var posLeft = posRowTwo.left - rowFour.width();
            if (posLeft < 0) {
                posLeft = posRowTwo.left + rowTwo.width();
            }
            rowFour.css({ left: posLeft, top: posRowTwo.top });
        }
        setTimeout(function () {
            // ที่ต้องใส่ setTimeout เพราะเวลากดจาก section widget มันไม่ขึ้น
            parent.$('.wys-panel').hide();
            rowFour.show();
            // alert()
            parent
                .$('.wys-rowFour')
                .find('#setfixedimg,.btn-custom,.title,#setfluidbanner')
                .show();
            //parent.$( ".accordion-panel" ).accordion("option", "active", 2 );
            //parent.$( ".background-prop" ).tabs("option", "active", 1 );
        }, 50);
    };
    RVwys.uikit.blockprop.rowParallaxSlide = function (oThis) {
        console.log('=================== function =================');
        console.log('RVwys.uikit.blockprop.rowParallaxSlide');
        console.log('==============================================');

        var rowFour = parent.$('.wys-rowFour');
        var rowTwo = parent.$('.wys-rowTwo');
        if (rowTwo.is(':visible')) {
            var posRowTwo = parent.$('.wys-rowTwo').position();
            var posLeft = posRowTwo.left - rowFour.width();
            rowFour.css({ left: posLeft, top: posRowTwo.top });
        }
        rowFour.show();

        parent.rowParallaxSlide = true;
        parent.currentSlide = oThis;
        //fb = $('#frameBody').get(0).contentWindow

        var img = $('li[data-banner=' + parent.currentSlide + ']').find('img');
        rowFour.find('#setfixedimg,.btn-custom,.title,#setfluidbanner').hide();
        rowFour.find('.section-bg').css({
            background: 'url(' + img.get(0).src + ') no-repeat 50% / contain',
        });
    };

    RVwys.uikit.blockprop.WebsiteBody = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-WebsiteBodyDesign, .panelWebsiteBody').show();
    };

    RVwys.uikit.blockprop.blockParallax = function () {
        parent.$('.wys-panel').hide();
        parent.$('.wys-rowThree').show();
        //parent.$( ".accordion-panel" ).accordion("option", "active", 2 );
        //parent.$( ".background-prop" ).tabs("option", "active", 0 );
    };

    RVwys.uikit.blockprop.blockAnimation = function () {
        parent.$('.wys-panel').hide();
        parent.$('.wys-pEffect').show();
        //parent.$( ".accordion-panel" ).accordion("option", "active", 2 );
        //parent.$( ".background-prop" ).tabs("option", "active", 0 );
    };

    RVwys.uikit.blockprop.createMasterPage = function (oThis) {
        var overlaypanel = $('<div class="overlaypanel"></div>').css({
            opacity: '0.5',
            position: 'absolute',
            left: '0px',
            top: '0px',
            width: $('body').width(),
            height: $('body').height(),
        });
        parent.$('body').prepend(overlaypanel);
        var mg = RVwys.getParentByClass($(oThis), 'mg');
        mg.find('.RVWYSIWYGAREA').each(function () {});
    };
    //rvwysiwyg history
    RVwys.history = {};
    RVwys.history.limit = 1000;
    RVwys.history.curLevel = 0;
    RVwys.history.levels = [];
    RVwys.history.preLevel = false;
    RVwys.history.editor = {};
    // 13(enter) 8(backspace) 46(delete)
    RVwys.history.isKeyCode = {};

    RVwys.history.ready = function () {
        this.levels[this.curLevel] = {};
        this.levels[this.curLevel]['html'] = $(RVwys.currentiFrame).html();
        this.levels[this.curLevel]['object'] = $(RVwys.currentEditor);
        this.curLevel++;
    };
    RVwys.history.pre = function (e) {
        this.preLevel = {};
        this.preLevel['html'] = $(RVwys.currentiFrame).html();
        this.preLevel['object'] = $(RVwys.currentiFrame);
        console.log('history-pre->' + this.preLevel['html']);
    };
    RVwys.history.add = function () {
        if (this.preLevel) {
            this.levels[this.curLevel] = this.preLevel;
            this.preLevel = false;
        } else {
            this.levels[this.curLevel] = {};
            this.levels[this.curLevel]['html'] = $(RVwys.currentiFrame).html();
            this.levels[this.curLevel]['object'] = $(RVwys.currentiFrame);
            console.log('levels : ', this.levels);
            console.log('curLevel : ', this.curLevel);
            console.log('add key -->' + $(RVwys.currentiFrame).html());
        }
        if (RVwys.history.curLevel == RVwys.history.limit) {
            RVwys.history.levels.splice(0, 1);
            this.curLevel--;
        }
        this.curLevel++;
        if (this.levels[this.curLevel]) {
            RVwys.history.levels.splice(
                this.curLevel,
                this.limit - this.curLevel
            );
        }
    };

    RVwys.history.keycode = function (e) {
        // undo redo keycode 90 89
        var aKey = { 90: 'undo', 89: 'redo' };
        $('history').remove();
        if (RVwys.ctrlKey && aKey[e.keyCode]) {
            RVwys.history[aKey[e.keyCode]]();
        } else {
            var isChr = String.fromCharCode.apply(null, [e.keyCode]);
            isChr = /[a-z0-9]/i.test(isChr);

            if (isChr && !RVwys.ctrlKey && !RVwys.altKey && !RVwys.shiftKey) {
                console.log(
                    'String.fromCharCode(e.keyCode)' +
                        String.fromCharCode(e.keyCode)
                );
                RVwys.insertRollHTML('<history></history>');
                RVwys.history.add();
            }
        }
    };
    RVwys.history.undo = function () {
        var fo = frameBody.contentWindow?.RVwys ?? RVwys;
        var isFrame = frameBody.contentWindow?.RVwys ? true : false;

        console.log('fo : ', fo);
        console.log('isFrame : ', isFrame);

        console.log('fo.history.curLevel->' + fo.history.curLevel);
        if (fo.history.curLevel > 0) {
            fo.history.curLevel--;
            var i = fo.history.curLevel - 1;
            if (fo.history.levels[i]) {
                console.log(
                    'undo history-' + i + '->' + fo.history.levels[i]['html']
                );
                fo.history.levels[i]['object'].html(
                    fo.history.levels[i]['html']
                );
                var oHistory = fo.history.levels[i]['object'].find('history');
                if (oHistory.get(0)) {
                    fo.history.levels[i]['object'].focus();
                    var sel = fo.currentEditor.getSelection();
                    var rangeHistory = fo.currentEditor.createRange();
                    try {
                        rangeHistory.setStartBefore(oHistory.get(0));
                        sel.removeAllRanges();
                        sel.addRange(rangeHistory);
                    } catch (e) {}
                    if (isFrame) {
                        frameBody.contentWindow.$('history').remove();
                    } else {
                        $('history').remove();
                    }
                    fo.history.levels[i]['object'].focus();
                    console.log('undo history focus');
                } else {
                    $(RVwys.currentiFrame).focus();
                }
            }
        } else if (fo.history.curLevel == 0) {
        } else {
            $(RVwys.currentiFrame).focus();
        }
    };
    RVwys.history.redo = function () {
        try {
            var fo = frameBody.contentWindow.RVwys;
            var isFrame = true;
        } catch (e) {
            var fo = RVwys;
            var isFrame = false;
        }
        if (fo.history.curLevel + 1 < fo.history.limit) {
            if (fo.history.levels[fo.history.curLevel]) {
                fo.history.curLevel++;
                var i = fo.history.curLevel - 1;
                console.log('redo history->' + fo.history.curLevel);
                fo.history.levels[i]['object'].html(
                    fo.history.levels[i]['html']
                );
                var oHistory = fo.history.levels[i]['object'].find('history');
                userSelection = fo.currentEditor.getSelection();
                fo.history.levels[i]['object'].focus();
                var sel = fo.currentEditor.getSelection();
                rangeHistory = fo.currentEditor.createRange();
                try {
                    rangeHistory.setStartBefore(oHistory.get(0));
                    sel.removeAllRanges();
                    sel.addRange(rangeHistory);
                } catch (e) {}
                if (isFrame) {
                    frameBody.contentWindow.$('history').remove();
                } else {
                    $('history').remove();
                }
                fo.history.levels[i]['object'].focus();
                console.log('redo history focus');
            }
        } else {
            $(RVwys.currentiFrame).focus();
        }
    };
    RVwys.history.reset = function (obj) {
        RVwys.history.levels = {};
        RVwys.history.curLevel = 0;
    };
    RVwys.history.list = function (obj) {};

    RVwys.rvLang = function (key) {
        return key;
    };

    RVwys.buildBlockTools = function (oThis) {
        oThis.append(
            $(parent.$('.tpl-blocktoolbars').html())
                .find('.cloneBlock')
                .click(function () {
                    RVwys.removePreviewWidget();
                    var oForm = $(this).closest('.uk-form');
                    //alert('ss')

                    var blockClone = $(this).parent().parent().clone();
                    blockClone.find('.blockTools').remove();

                    if (oForm.get(0)) {
                        blockClone
                            .find('input,textarea,select')
                            .unbind('mousedown')
                            .mousedown(function () {
                                RVwys.uikit.formInputMousedown($(this));
                            });
                        var m = new Date().getTime();
                        blockClone
                            .find(
                                '[id^=rv-field-design],[id^=rv-form-design],[id^=rv-field-multi-design],[id^=rv-form-multi-design]'
                            )
                            .each(function () {
                                $(this).attr({
                                    id: $(this).attr('id') + m,
                                    //,'name':$(this).attr('name')+m
                                });
                            });
                    }

                    $(this).parent().parent().after(blockClone);
                    blockClone
                        .find('.RVWYSIWYGAREA')
                        .each(function () {
                            var id = $(this).attr('id') + $(this).index();
                            $(this).attr('id', id);
                            var testEditor = RVwys.EditorByClass(
                                '#' + id,
                                true
                            );
                        })
                        .eq(0)
                        .focus();
                })
                .end()
                .find('.removeBlock')
                .click(function () {
                    var oForm = $(this).closest('.uk-form');
                    $(this).parent().parent().remove();
                    setTimeout(function () {
                        RVwys.uikit.checkEmail(oForm);
                    }, 50);

                    if ($(this).parent().parent().find('img').get(0)) {
                        $('.image-editor-tool,.icon-widget-preview').hide();
                    }
                })
                .end()
                .find('.blockAnimation')
                .click(function () {
                    //alert('ss')
                    RVwys.uikit.blockprop.blockAnimation();
                })
                .end()
                .find('.parallaxBlock')
                .click(function () {
                    RVwys.uikit.blockprop.blockParallax();
                })
                .end()
                .css('position', 'absolute')
        );
    };
    RVwys.removePreviewWidget = function () {
        console.log(
            '-----------------------------------------------------------'
        );
        //if ($("#frameBody").get(0))
        console.log($('body').get(0));
        console.log($('.closePreviewWidget'));
        console.log($('#frameBody').get(0));
        let o = $;
        if ($('#frameBody').get(0)) {
            o = $('#frameBody').get(0).contentWindow.$;
        }
        o('.closePreviewWidget').remove();

        o('.mgclone').remove();
        o('.mgMaster').removeClass('mgMaster');
        o('.previewWidgetTools').hide();
    };

    RVwys.htmlEntities = function (str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    RVwys.loadMyImages = function () {
        if (parent.myimages) {
            console.log('my image data');
            console.log('parent.myimages: ', parent.myimages);
            console.log('parent.storeimages: ', parent.storeimages);
            console.log('parent.tagfolder: ', parent.tagfolder);
            console.log(Object.keys(parent.myimages));

            // RVwys.imagemanager.addView(parent.aFreeImages,'all');
            var maxItem = Object.keys(parent.myimages).length;
            if (parent.$('.workspace').html() == '') {
                myImageListProcess = setTimeout(function () {
                    RVwys.imagemanager.myImageTagFolder();
                    RVwys.imagemanager.myImageList(
                        maxItem - 1,
                        0,
                        Object.keys(parent.myimages)
                    );
                }, 50);
            }
        } else {
            var overlaypanel = $(
                '<div class="overlaypanel">' +
                    '<p style="margin-top:40px;">' +
                    rvLang(
                        'This case long time depending on the number of files or size image.'
                    ) +
                    '</p>' +
                    '<img class="loading" src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                    '</div>'
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });
            parent.$('body').append(overlaypanel);

            var frmParam = '&rvsMgr=rvwysiwyguikit&rvsAct=buildImagesJson';
            wysurl = parent.RVS_AJAX_INDEX;
            wysurl = wysurl.replace('rvwysiwyguikit', 'sitebuilder');
            parent.jQuery.sitebuilder.Ajax.connect(frmParam, {
                url: wysurl,
                waitDialog: function (ev) {},
                callback: {
                    doError: function (data) {
                        parent.$('.overlaypanel').remove();
                    },
                    doSuccess: function (data) {
                        parent.myimages = data.myimages;
                        parent.storeimages = data.storeimages;
                        parent.tagfolder = data.tagfolder;

                        console.log('my image data');
                        console.log(parent.myimages);
                        console.log(parent.storeimages);
                        console.log(parent.tagfolder);
                        console.log(Object.keys(parent.myimages));
                        // RVwys.imagemanager.addView(parent.aFreeImages,'all');
                        maxItem = Object.keys(parent.myimages).length;
                        console.log('maxItem->' + maxItem);
                        //alert(Object.keys(parent.myimages))

                        RVwys.imagemanager.myImageList(
                            maxItem - 1,
                            0,
                            Object.keys(parent.myimages)
                        );
                        RVwys.imagemanager.addTagfolder();
                        RVwys.imagemanager.myImageTagFolder();

                        parent.$('.overlaypanel').remove();
                    },
                },
            });
        }
    };

    var scrollDesignModeInVal = null;
    var scrollSourceModeInVal = null;
    var processUpdateSource = null;
    var pointerMode = 'design';
    $(document).ready(function () {
        setTimeout(function () {
            /*
        var setToolbar = themeToolbar.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');
        var setFooter = themeFooter.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');
        var setRightbar = themeRightbar.replace(/&lt;/img,'<').replace(/&gt;/img,'>').replace(/&quot;/img,'"');

        //replace constain
        setToolbar = themeToolbar.replace(/\[[(USER_EMAIL|cdnURL)\]]/img,function(m,i){

        return parent[i];
        });
        setFooter = themeFooter.replace(/\[[(USER_EMAIL|cdnURL)\]]/img,function(m,i){

            return parent[i];
            });
        setRightbar = themeRightbar.replace(/\[[(USER_EMAIL|cdnURL)\]]/img,function(m,i){

            return parent[i];
            });

        var oToolbar = $('<div></div>').html(setToolbar).each(function(){

        	$(this).end().find('.sprite_wysiwyg, .sprite_wysiwyg_big,.dtbarimage,.dtbartext,.dtbartable,.wysiwyg_title').each(function(){
                if ($(this).attr('title') != undefined) {
                    $(this).attr('title',rvLang($(this).attr('title')));
                }
            })
        });
        var oRightbar = $('<div></div>').html(setRightbar).each(function(){
            $(this).find('lang').each(function(){
                var thisLang = (aLang[$(this).html()]) ? aLang[$(this).html()]: '&gt;'+$(this).html()+'&lt;';
                thisLang = thisLang.replace(/(<script[^>]*?>.*?<\/script\s*>|<style[^>]*?>.*?<\/style\s*>)/img,'');
                $(this).html(thisLang);
            }).end().find('.sprite_wysiwyg, .sprite_wysiwyg_big,.dtbarimage,.dtbartext,.dtbartable,.wysiwyg_title').each(function(){
                if ($(this).attr('title') != undefined) {
                    $(this).attr('title',rvLang($(this).attr('title')));
                }
            })
        });
        var oFooter = $('<div></div>').html(setFooter).each(function(){
            $(this).find('lang').each(function(){
                $(this).html((aLang[$(this).html()]) ? aLang[$(this).html()]: '&gt;'+$(this).html()+'&lt;');
            }).end().find('.sprite_wysiwyg, .sprite_wysiwyg_big').each(function(){
                if ($(this).attr('title') != undefined) {
                    $(this).attr('title',rvLang($(this).attr('title')));
                }
            });
        });
        themeToolbar = oToolbar.html();
        themeRightbar = oRightbar.html();
        themeFooter = oFooter.html();
        oToolbar.remove();
        oFooter.remove();
        oRightbar.remove();
    		 */
            var custombody = $('custombody').get(0)
                ? $('custombody').html()
                : '';

            if (!parent.$('#frameBody').get(0)) {
                var html = $('html').html();
                var isSRC = $('script[src*="js.php"]').attr('src');

                frameBody =
                    '<div id="fBody" style="display:none;" >' +
                    '<iframe src="" id="frameBody" name="frameBody" align="middle" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0" frameborder="0" scrolling="auto" src="" ></iframe></div>';
                if (!$('#qunit').get(0)) {
                    if (!custombody) {
                        //   $('body').html(custombody);
                        $('body').html('');
                    }
                } else {
                    html = html.replace(/qunit.js/gim, '');
                }
                $('body').append(frameBody);
                var frameBody = $('#frameBody').get(0);
                var loadURL = RVwys.runURL
                    ? RVwys.runURL
                    : window.location.href;
                $('<div id="dataRoll"></div>').load(
                    loadURL,
                    function (html, status, xhr) {
                        //console.log(xhr)
                        //console.log(xhr.status)
                        //alert(error)
                        if (status == 'error') {
                            var aLink =
                                '<a href="' +
                                loadURL +
                                '" target="_blank">' +
                                loadURL +
                                '</a>';
                            console.pop.error(
                                aLink + '  ' + status + xhr.status
                            );
                            return;
                        }
                        html = html
                            .replace(/\&lt;/gim, '<')
                            .replace(/\&gt;/gim, '>');
                        html = html
                            .replace(/<\?/gim, '<!--?')
                            .replace(/\?>/gim, '?-->');
                        $(frameBody).height($(document).height() - 84);
                        var frameBodyDoc =
                            frameBody.contentWindow ||
                            frameBody.contentDocument;
                        if (frameBodyDoc.document)
                            frameBodyDoc = frameBodyDoc.document;
                        if (typeof RVwys.OverRide == 'function') {
                            html = RVwys.OverRide(html);
                        }
                        //cache webkit
                        var ran5 = Math.round(Math.random() * 90000);
                        html = html.replace(
                            /\.css\"/gim,
                            '.css?v=' + ran5 + '"'
                        );
                        frameBodyDoc.open();
                        frameBodyDoc.write(html);
                        frameBodyDoc.close();

                        setTimeout(function () {
                            var aClearVal = {};
                            aClearVal['text'] = true;
                            aClearVal['textarea'] = true;
                            /*why remove input value
                    $(frameBodyDoc).contents().find('input').each(function(){
                        if (aClearVal[$(this).get(0).type.toLowerCase()]) {
                            $(this).val('');
                        }
                    });
                    $(frameBodyDoc).contents().find('textarea').each(function(){
                        if (aClearVal[$(this).get(0).type.toLowerCase()]) {
                            $(this).val('');
                        }
                    });
                    */
                            $(frameBodyDoc)
                                .contents()
                                .find("link[href*='rvwysiwyg']")
                                .remove();
                            $(frameBodyDoc)
                                .contents()
                                .find('style')
                                .each(function () {
                                    var str = $(this).attr('src');
                                    if (str != undefined) {
                                        var isToolbarCss = str.indexOf(
                                            'css.php'
                                        );
                                        if (isToolbarCss) {
                                            $(this).remove();
                                        }
                                        isToolbarCss =
                                            themeName == 'uikit'
                                                ? str.indexOf(
                                                      'rvwysiwyg-uikit.css'
                                                  )
                                                : str.indexOf('rvwysiwyg.css');
                                        if (isToolbarCss) {
                                            $(this).remove();
                                        }
                                    }
                                });
                            var mainwysCssurl = $('#mainwys-css').get(0)
                                ? $('#mainwys-css').attr('href')
                                : '';
                            var isDevModeCss = editmode
                                ? '1'
                                : mainwysCssurl.match(/css.php/gim);

                            var pathVendor = RVwys.baseUrl.replace(
                                'rvwysiwyguikit',
                                ''
                            );
                            var path_editableuikit = '';
                            if (parent.wex.wysiwygMixManifest) {
                                var parseWysiwygMixManifest =
                                    parent.wex.wysiwygMixManifest;
                                var path_editableuikit =
                                    parent.wex.app_env != 'local'
                                        ? parent.wex.cdn.cdnURL +
                                          '/w' +
                                          parseWysiwygMixManifest[
                                              '/css/editableuikit.css'
                                          ]
                                        : pathVendor +
                                          '/vendor/rvsitebuilder/wysiwyg' +
                                          parseWysiwygMixManifest[
                                              '/css/editableuikit.css'
                                          ];
                            } else {
                                alert('Load file editableuikit.css fail !');
                            }
                            /*
                    var editorCssfile = $('<link rel="stylesheet"  href="' + path_editableuikit +'" />').on('load',function(){
                    	//alert($('#menu').get(0))
                    	var f = parent.$('#frameBody').get(0).contentWindow;
                    	//alert(f.$("#menu").get(0))

                    	setTimeout(function(){
                    		RVwys.showMenuRightBar();

                    	},50);
                    });
                    //alert(editorCssfile)
*/

                            // $(frameBodyDoc).contents().find("head").append(editorCssfile);
                            RVwys.showMenuRightBar();
                            if (!document.all) {
                                parent.scrollDesignModeInVal = parent.setInterval(
                                    function () {
                                        if ('scrollDesignMode' in RVwys) {
                                            RVwys.scrollDesignMode();
                                        }
                                    },
                                    1000
                                );
                            }
                            if (!document.all) {
                                parent.scrollSourceModeInVal = parent.setInterval(
                                    function () {
                                        if ('scrollSourceMode' in RVwys) {
                                            RVwys.scrollSourceMode();
                                        }
                                    },
                                    1000
                                );
                            }
                            $(frameBodyDoc).ready(function () {
                                parent.$('.outPopUp').remove();
                                //alert('s')
                                parent.$('#fBody,#topbar').show();
                                parent
                                    .$('#topbar')
                                    .css('visibility', 'visible');
                            });
                            $(frameBodyDoc).mouseover(function () {
                                parent.pointerMode = 'design';
                            });

                            removeRVwysiwyCss();
                        }, 500);
                    }
                );
            }
        }, 1000);
    });

    $.fn.placeHoldersRaw = function () {
        var data = $(this).placeHolders().html();
        var a = $('<div></div>').html(data);
        var tag = 'php';
        var phpIntoTag = /(<[^>]*?)(<img[^>]*?>)([^<]*?>)/gim;
        var tagPHP = /(<!--\?.*?\?-->)/gim;
        data = data.replace(tagPHP, function (m, scpPHP) {
            return (
                '<img type="' +
                tag +
                '"' +
                'class="' +
                tag +
                '" ' +
                'src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/' +
                tag +
                '.gif"' +
                'data = "' +
                escape(scpPHP) +
                '"' +
                '/>'
            );
        });
        data = data.replace(phpIntoTag, function (m, start, i, end) {
            obj = $(i);
            var tag = obj.attr('type');
            var data = obj.attr('data');
            data = tag == 'php' ? unescape(data) : m;
            data = data
                .replace(/<!--\?/gim, '&lt;?')
                .replace(/\?-->/gim, '?&gt;');
            if (start && end) {
                return start + data + end;
            }
        });
        $(this).html(data);
        return $(this);
    };
    $.fn.placeHolders = function () {
        return $(this)
            .find('script, style, link')
            .each(function () {
                var data = escape($(this).html());
                var tag = $(this).get(0).tagName.toLowerCase();
                var tagname = tag;
                if (tag == 'link') {
                    isRel = $(this).attr('rel');
                    var isURLROLL = $(this).attr('href');
                    switch (isRel) {
                        case 'stylesheet':
                            tag = 'style';
                            break;
                        case 'script':
                            tag = 'script';
                            break;
                        default:
                            break;
                    }
                } else {
                    var isURLROLL = $(this).attr('src');
                }
                loadScriptExt['url' + isURLROLL] = isURLROLL;
                $.getScript(isURLROLL)
                    .done(function (script, textStatus) {})
                    .fail(function (jqxhr, settings, exception) {});
                var isAttrs = escape(JSON.stringify($(this).attrs()));
                $(this).replaceWith(
                    '<img type="' +
                        tag +
                        '"' +
                        'tagname= "' +
                        tagname +
                        '"' +
                        'class="' +
                        tag +
                        '" ' +
                        'src="' +
                        parent.wex.url.WYS_IMG_URL +
                        'images/' +
                        tag +
                        '.gif"' +
                        'data= "' +
                        data +
                        '"' +
                        'attrs= "' +
                        isAttrs +
                        '"' +
                        '/>'
                );
            })
            .end();
    };

    $.fn.unplaceHolders = function (isType) {
        //siType = origenal || editor
        var isStripTag = { style: true, script: true, php: true };
        $(this)
            .find('img')
            .each(function () {
                var tag = $(this).attr('type');
                var tagname = $(this).attr('tagname');
                var data = $(this).attr('data');
                var attrs = $(this).attr('attrs');
                var getData;
                if (isStripTag[tag]) {
                    if (tag == 'php') {
                        getData = unescape(data);
                        getData = replaceHolderTags(getData);
                        switch (isType) {
                            case 'origenal':
                                getData = getData
                                    .replace(/\#amplt;/gim, '&lt;')
                                    .replace(/\#ampgt;/gim, '&gt;')
                                    .replace(/\&lt;\?/gim, '<!--?')
                                    .replace(/\?\&gt;/gim, '?-->');
                                break;
                            case 'textarea':
                                getData = getData
                                    .replace(/\#amplt;\?/gim, '&lt;?')
                                    .replace(/\?\#ampgt;/gim, '?&gt;')
                                    .replace(/\#amplt;/gim, '&lt;')
                                    .replace(/\#ampgt;/gim, '?&gt;');
                                break;
                            default:
                                break;
                        }
                    } else {
                        var tagAttr = JSON.parse(unescape(attrs));
                        getData = $(
                            '<' +
                                tagname +
                                '>' +
                                unescape(data) +
                                '</' +
                                tagname +
                                '>'
                        );
                        getData.attr(tagAttr);
                    }
                    try {
                        $(this).replaceWith(getData);
                    } catch (e) {
                        alert('your script include error');
                    }
                }
            });
        $(this).find('.layoutResize').remove();
        $(this).find('.layoutResize').remove();
        $(this).find('.wgetAll').remove();
        return $(this);
    };
    $.fn.attrs = function () {
        var a, aLength, attributes, map;
        if (this[0] && arguments.length === 0) {
            map = {};
            attributes = this[0].attributes;
            aLength = attributes.length;
            for (a = 0; a < aLength; a++) {
                map[attributes[a].name.toLowerCase()] = attributes[a].value;
            }
            return map;
        }
        return _old.apply(this, arguments);
    };
    $.fn.getValWYS = function () {
        frmData = $(this).find('#frm_' + $(this).get(0).id);
        if (frmData.get(0)) {
            return frmData.contents().find('body').html();
        }
        return false;
    };
    $.fn.setValWYS = function () {
        frmData = $(this).find('#frm_' + $(this).get(0).id);
        if (frmData.get(0)) {
            return frmData.contents().find('body').html();
        }
        return false;
    };
    $.fn.focusWYS = function () {
        frmData = $(this).find('#frm_' + $(this).get(0).id);
        if (frmData.get(0)) {
            return frmData.contents().find('body').html();
        }
        return false;
    };
    $.fn.internalRVwysiwyg = function () {
        var thisEditorMini = $(this);
        var thisToolbarMini = $(this).find('.internalWYSToolbar');
        var thisDataMini = $(this).find('.internalWYSData');
        if (!thisToolbarMini.get(0)) {
            alert(rvLang('missing css class miniWYSToolbar'));
            $(this).hide();
            return false;
        }
        if (!thisDataMini.get(0)) {
            alert(rvLang("missing css class 'miniWYSData"));
            $(this).hide();
            return false;
        }
        var id = $(this).get(0).id;
        var thisFrm = $(
            '<iframe id="frm_' + id + '" width = "100%" height="50"></iframe>'
        );
        $(this).append(thisFrm);
        thisFrmDoc =
            thisFrm.get(0).contentWindow || thisFrm.get(0).contentDocument;
        if (thisFrmDoc.document) thisFrmDoc = thisFrmDoc.document;
        thisFrmDoc.open();
        var miniHTML = minihtml.replace(
            /#(HEADER|CONTENT)#/gim,
            function (m, i) {
                str = '';
                switch (i) {
                    case 'HEADER':
                        str = '';
                        break;
                    case 'CONTENT':
                        str =
                            thisDataMini.get(0).tagName.toLowerCase() ==
                            'textarea'
                                ? thisDataMini.val()
                                : thisDataMini.html();

                        break;
                    default:
                        break;
                }
                return str;
            }
        );
        thisFrmDoc.write(miniHTML);
        thisFrmDoc.close();
        $(thisFrmDoc).mousedown(function () {
            RVwys.currentEditor = $(this).get(0);
            RVwys.currentiFrame = thisFrm;
        });
        $(thisFrmDoc).keyup(function (e) {
            RVwys.activeEventButtonStarteMini(thisEditorMini);
        });
        $(thisFrmDoc).mouseup(function (e) {
            range = RVwys.getRange();
            if (range) {
                RVwys.activeEventButtonStarteMini(thisEditorMini);
            }
        });
        return $(this);
    };
    $.fn.extend({
        hasClasses: function (selectors) {
            var self = this;
            for (var i in selectors) {
                if ($(self).hasClass(selectors[i])) return true;
            }
            return false;
        },
    });

    $.fn.hasAnyClass = function () {
        for (var i = 0; i < arguments.length; i++) {
            var classes = arguments[i].split(' ');
            for (var j = 0; j < classes.length; j++) {
                if (this.hasClass(classes[j])) {
                    return true;
                }
            }
        }
        return false;
    };
})(jQuery);

function removeRVwysiwyCss() {
    console.log('removeRVwysiwyCss()');
    if (themeName == 'uikit') {
        var nameCss = 'rvwysiwyg-uikit.css';
    } else {
        var nameCss = 'rvwysiwyg.css';
    }
    var rvwysiwygCSS = $('#frameBody')
        .contents()
        .find('link[href*="' + nameCss + '"]');
    if (rvwysiwygCSS.attr('href')) {
        rvwysiwygCSS.remove();
    } else {
        setTimeout(function () {
            //removeRVwysiwyCss()
        }, 500);
    }
}
function replaceHolderTags(getData) {
    return getData.replace(/\<!--\?(.*?)\?--\>/gim, function (m, i) {
        return (
            '#amplt;?' +
            i.replace(/\</gim, '#amplt;').replace(/\>/gim, '#ampgt;') +
            '?#ampgt;'
        );
    });
}
function rvLang(key) {
    return key;
}
var Base64 = {
    _keyStr:
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    encode: function (input) {
        var output = '';
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = Base64._utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output =
                output +
                this._keyStr.charAt(enc1) +
                this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) +
                this._keyStr.charAt(enc4);
        }
        return output;
    },
    // public method for decoding
    decode: function (input) {
        var output = '';
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = Base64._utf8_decode(output);
        return output;
    },
    _utf8_encode: function (string) {
        var string = string.replace(/\r\n/g, '\n');
        var utftext = '';
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    },
    _utf8_decode: function (utftext) {
        var string = '';
        var i = 0;
        var c = (c1 = c2 = 0);
        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(
                    ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
                );
                i += 3;
            }
        }
        return string;
    },
};

function handlepaste(elem, e) {
    var savedcontent = elem.innerHTML;
    var range = RVwys.getRange();
    var isRangeText = RVwys.isRangeText(range);
    var localURL = location.origin;
    var isLocalHTTPS =
        localURL != '' ? (localURL.match(/^https\:/g) ? true : false) : false;
    if (
        e &&
        e.originalEvent.clipboardData &&
        e.originalEvent.clipboardData.getData
    ) {
        //		Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
        console.log('isRangeText' + isRangeText);
        console.log(range);
        console.log(e.originalEvent.clipboardData.types);
        if (
            /text\/html/.test(e.originalEvent.clipboardData.types) ||
            e.originalEvent.clipboardData.types[0] == 'text/html'
        ) {
            var text = e.originalEvent.clipboardData.getData('text/html');
            var pasteRow = $('<div class="pasteRow"></div>')
                .html(text)
                .each(function () {
                    $(this).find('meta').remove(); // ต้องใส่ จะมีบางกรณีที่ copy จาก content ใส body มาแล้วมี <meta>ขึ้นมาเอง
                    // ต้องปรับเพิ่ม เราเป็นhttps เอา http วาง ต้องขึ้น pnotify case tag ที่มี src href
                    $(this)
                        .find('[src],[href]')
                        .each(function () {
                            var getUrlImg =
                                $(this).attr('src') || $(this).attr('href');
                            var attrKey = $(this).attr('src')
                                ? 'src'
                                : $(this).attr('href')
                                ? 'href'
                                : false;
                            var useHTTP = getUrlImg.match(/^http\:/g)
                                ? true
                                : false;
                            if (isLocalHTTPS && useHTTP) {
                                parent.console.pop.notice(
                                    'found http url "' +
                                        attrKey +
                                        '" "' +
                                        getUrlImg +
                                        '"'
                                );
                            }
                            if (attrKey) {
                                var repDomain = getUrlImg.replace(localURL, '');
                                $(this).attr(attrKey, repDomain);
                            }
                        });
                });
            $.when(pasteRow, $('img').find('')).done(function () {
                console.log('paste --->');
                console.log(pasteRow.html());
                RVwys.execDesignMode('insertHTML', true, pasteRow.html());
                pasteRow.remove();
            });
        } else if (/text\/plain/.test(e.originalEvent.clipboardData.types)) {
            //			elem.innerHTML = e.originalEvent.clipboardData.getData('text/plain');
            RVwys.insertHTML(
                e.originalEvent.clipboardData.getData('text/plain')
            );
        } else {
            //			elem.innerHTML = "";
        }

        //		waitforpastedata(elem, savedcontent);
        if (e.preventDefault) {
            e.stopPropagation();
            e.preventDefault();
        }
        return false;
    }
    // Everything else - empty editdiv and allow browser to paste content into it, then cleanup
    console.log('Big Else');
    elem.innerHTML = '';
    waitforpastedata(elem, savedcontent);
    return true;
}

function rvwystest() {
    frameBody = parent.$('#frameBody').get(0);
    frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
    if (frameBodyDoc.document) frameBodyDoc = frameBodyDoc.document;
    html = frameBody.contentWindow.$('html').html();
    frameBodyDoc.open();
    frameBodyDoc.write(html);
    frameBodyDoc.close();
}
function waitforpastedata(elem, savedcontent) {
    if (elem.childNodes && elem.childNodes.length > 0) {
        processpaste(elem, savedcontent);
    } else {
        that = {
            e: elem,
            s: savedcontent,
        };
        that.callself = function () {
            waitforpastedata(that.e, that.s);
        };
        setTimeout(that.callself, 20);
    }
}
